import $ from 'jquery';
import _ from 'lodash';
import ko from '@tko/build.knockout';
import moment from 'moment-timezone';
import templateMarkup from 'raw-loader!./call-details-view.html';
import DataService from '../../services/data.service';
import DataProvider from '../../../../app/data-framework/data-provider';
import WebResourceSecure from '../../services/web-resource-secure.service';
import Rx from '../../../../thirdPartyForks/rx.all';
import UtilsService from '../../../../services/utils.service';
import Tabulator from 'tabulator-tables';
import Highcharts from 'highcharts/highstock.src';
import addAccessibility from 'highcharts/modules/accessibility';
import DragPanes from 'highcharts/modules/drag-panes';
import SeriesLabel from "highcharts/modules/series-label";
import TranslationService from '../../../../services/translation.service';
import CommonDialog from '../../../../components/modal-dialog/common-dialog/common-dialog';
import LoginService from "../../../../services/login.service";
import NetworksSteps from "../../../admin/components/BuildingsSpaces/NetworksGuidelines.vue";

DragPanes(Highcharts);
SeriesLabel(Highcharts);
addAccessibility(Highcharts);

const TWO_HOURS = 2 * 60 * 60 * 1000;
const EXTERNAL_GAP_SIZE = 150 * 1000;
const INTERNAL_GAP_SIZE = 120 * 1000;
const SENT_TEXT = 'Thanks for your feedback!';

Number.isInteger = Number.isInteger || function(value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};

function getReadableBitrateString(bits) {
    if (!_.isFinite(bits)) return '';

    var kilobits = bits / 1000;
    if (bits <= 0 || bits >= 100) {
        return kilobits.toLocaleString('en-US', {maximumFractionDigits: (Number.isInteger(kilobits) ? 0 : 1)}) + ' kbps';
    } else {
        return kilobits.toLocaleString('en-US', {maximumFractionDigits: (Number.isInteger(kilobits) ? 0 : 3)}) + ' kbps';
    }
}

function getReadableFramerateString(fps) {
    if (fps === 0 || fps === 0.0 || fps >= 0.1) {
        return fps.toFixed(Number.isInteger(fps) ? 0 : 1) + ' fps';
    } else {
        return fps.toFixed(Number.isInteger(fps) ? 0 : 3) + ' fps';
    }
}

function getReadablePacketLossString(loss) {
    if (loss === 0 || loss === 0.0 || loss >= 0.001) {
        return loss.toLocaleString('en-US', {maximumFractionDigits: (Number.isInteger(loss) ? 0 : 3)}) + '%';
    } else {
        return loss.toLocaleString('en-US', {maximumFractionDigits: (Number.isInteger(loss) ? 0 : 6)}) + '%';
    }
}

function getReadablePercentageString(loss) {
    if (loss === 0 || loss === 0.0 || loss >= 0.01) {
        return loss.toLocaleString('en-US', {maximumFractionDigits: (Number.isInteger(loss) ? 0 : 2)}) + '%';
    } else {
        return loss.toLocaleString('en-US', {maximumFractionDigits: (Number.isInteger(loss) ? 0 : 5)}) + '%';
    }
}

function getReadableDbString(level) {
    return level + ' dB';
}

function getReadableRatioString(loss) {
    return getReadablePercentageString(loss*100);
}

function getReadableBitrateString2(bytes) {
    var byteUnits = [' bps', ' Kbps', ' Mbps', ' Gbps', ' Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps'];
    if (bytes < 1000) {
        return bytes + byteUnits[0];
    }
    var i = 0;
    while (bytes >= 1000 && i < byteUnits.length) {
        bytes = bytes / 1000;
        i++;
    }

    return Math.max(bytes, 0.1).toFixed(Number.isInteger(bytes) ? 0 : 1) + byteUnits[i];
}

function getBitrateIcon(bytes) {
    let color = ' fonticonDarkGray';
    if (bytes > 0) { // > 0 Mbps
        color = ' fonticonRed';
    }
    if (bytes >= 1500000) { // >= 1.5 Mbps
        color = ' fonticonYellow';
    }
    if (bytes >= 100000000) { // >= 100 Mbps
        color = ' fonticonGreen';
    }
    var byteUnits = ['fal fa-tachometer-slowest', 'fal fa-tachometer-slow', 'fal fa-tachometer-average', 'fal fa-tachometer-fast', 'fal fa-tachometer-fastest'];
    var i = 0;
    if (bytes >= 1500000) { // >= 1.5 Mbps
        i = 1;
    }
    if (bytes >= 10000000) { // >= 10 Mbps
        i = 2;
    }
    if (bytes >= 100000000) { // >= 100 Mbps
        i = 3;
    }
    if (bytes >= 1000000000) { // >= 1 Gbps
        i = 4;
    }

    return '<i class="'+ byteUnits[i] + color +'"></i> ';
}

function getReadableTime(value) {
    if (value) {
        var datetime = moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
        return datetime.format('HH:mm:ss');
    } else {
        return "now";
    }
}

function getReadableDay(value) {
    if (value) {
        var datetime = moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
        return datetime.format('DD MMM');
    } else {
        return moment().format('DD MMM');
    }
}

function getReadableYear(value) {
    if (value) {
        var datetime = moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
        return datetime.format('YYYY');
    } else {
        return moment().format('YYYY');
    }
}

function getTime(value) {
    if (value) {
        var datetime = moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
        return datetime.valueOf();
    } else {
        return moment().valueOf();
    }
}

function getDay(startTime) {
    if (startTime) {
        return startTime.substring(0,10);
    } else {
        return '2000-01-01';
    }
}

function mergeChartData(dataPartA, dataPartB) {
    var merged = [];
    $.each(dataPartA, function (i, d) {
        merged[i] = d.concat(dataPartB[i]);
    });
    return merged;
}

function mergeChartData2(dataObjPartA, dataObjPartB) {
    return _.mergeWith(dataObjPartA, dataObjPartB, (objValue, srcValue) => {
        if (_.isArray(objValue)) {
            return objValue.concat(srcValue);
        }
    });
}

function formatNumber(num) {
  let toNumber = _.toNumber(num);
  if (toNumber < 1.0) {
    return "1";
  }
  return toNumber.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

function formatRawNumber(num) {
  let toNumber = _.toNumber(num);
  if (toNumber === 0) {
    return '0';
  }

  let digits = 2;
  let limit = 0.01;
  while (Math.abs(toNumber) < limit) {
    digits++;
    limit /= 10;
  }
  let s = toNumber.toLocaleString(undefined, { maximumFractionDigits: digits });
  return s;
}

class CallDetailsView {
    constructor(params) {
        var self = this;
        self.dataProvider = DataProvider.getInstance();
        self.showDiagnostics = LoginService.userObject.smartDiagnostics;
        self.nothingWrong = ko.observable('');
        self.SENT_TEXT = SENT_TEXT;
        self.feedbackText = ko.observable('');
        self.callIssues = ko.observable([]);
        self.translationService = new TranslationService();
        self.params = params;
        self.route = params.route;
        self.tabId = 0;
        self.openUrlInNewPage = ko.pureComputed(function () { return '#monitoring/calls/' + self.data().start_time + '/' + self.data().call_id; });
        self.inOwnContainer = self.route().page !== 'assurance-app-view';

        self.summaryLoaded = ko.observable(false);
        self.data = ko.observable();
        self.source = ko.observable();
        self.sourceIp = ko.observable('empty');
        self.target = ko.observable();
        self.targetIp = ko.observable('empty');

        self.meetingName = ko.observable();
        self.meetingId = ko.observable();

        self.dataSource = ko.observable();
        self.qualityDetailsUpdated = ko.observable();
        self.recordsUpdated = ko.observable();
        self.startDay = ko.observable();
        self.startYear = ko.observable();
        self.startTime = ko.observable();
        self.endDay = ko.observable();
        self.endTime = ko.observable();
        self.startTimeRaw = ko.observable();
        self.endTimeRaw = ko.observable();
        self.duration = ko.pureComputed(function() {
            var starttime = moment(self.startTimeRaw(), 'YYYY-MM-DDTHH:mm:ss.SSSZ');
            var endtime = (self.endTimeRaw()) ? moment(self.endTimeRaw(), 'YYYY-MM-DDTHH:mm:ss.SSSZ') : moment();
            if (starttime.isValid()) {
                var display = UtilsService.getDurationDisplayTextFromDiff(starttime,  endtime);

                return display;
            }
            return '';
        }, self);
        self.quality = ko.observable();
        self.avgQuality = ko.observable();
        
        self.good = ko.observable();
        self.fair = ko.observable();
        self.bad = ko.observable();
        self.unknown = ko.observable();
        
        self.good.subscribe(function() {
          let element = document.querySelector('#goodQualityContainer');
          if (element) {
            let adbId = element.getAttribute('aria-describedby');
            if (adbId) {
              let ttEl = document.querySelector('#'+adbId + ' .tooltip-inner');
              if (ttEl){
                setTimeout(() => {ttEl.innerHTML = self.goodRawDisplay();});
              }
            }
          }
        });
        self.fair.subscribe(function() {
          let element = document.querySelector('#fairQualityContainer');
          if (element) {
            let adbId = element.getAttribute('aria-describedby');
            if (adbId) {
              let ttEl = document.querySelector('#'+adbId + ' .tooltip-inner');
              if (ttEl){
                setTimeout(() => {ttEl.innerHTML = self.fairRawDisplay();});
              }
            }
          }
        });
        self.bad.subscribe(function() {
          let element = document.querySelector('#badQualityContainer');
          if (element) {
            let adbId = element.getAttribute('aria-describedby');
            if (adbId) {
              let ttEl = document.querySelector('#'+adbId + ' .tooltip-inner');
              if (ttEl){
                setTimeout(() => {ttEl.innerHTML = self.badRawDisplay();});
              }
            }
          }
        });
        self.unknown.subscribe(function() {
          let element = document.querySelector('#unknownQualityContainer');
          if (element) {
            let adbId = element.getAttribute('aria-describedby');
            if (adbId) {
              let ttEl = document.querySelector('#'+adbId + ' .tooltip-inner');
              if (ttEl){
                setTimeout(() => {ttEl.innerHTML = self.unknownRawDisplay();});
              }
            }
          }
        });
        
        self.qot = ko.observable(localStorage.getItem('qot') || sessionStorage.getItem('qot'));

        self.records = ko.observableArray();

        self.currentQuality = ko.pureComputed(function () {
           if (self.avgQuality() && self.avgQuality() !== 'UNKNOWN') {
             return self.avgQuality();
           }
           return self.quality();
        });

        self.usingAvgQuality = ko.pureComputed(function () {
           return  self.avgQuality() && self.avgQuality() !== 'UNKNOWN';
        });

        self.qualityLabel = ko.pureComputed(function () {
          let suffix = self.usingAvgQuality() ? ' (Overall)' : ' (Latest)';
           return 'Quality'+suffix;
        });

        self.percentGoodFlexGrow = ko.pureComputed(function () {
          if (self.good() != null) {
            return (self.good()); 
          }
          return '1';
        });

        self.percentFairFlexGrow = ko.pureComputed(function () {
          if (self.fair() != null) {
            return (self.fair()); 
          }
          return '1';
        });

        self.percentBadFlexGrow = ko.pureComputed(function () {
          if (self.bad() != null) {
            return (self.bad()); 
          }
          return '1';
        });

        self.percentUnknownFlexGrow = ko.pureComputed(function () {
          if (self.unknown() != null) {
            return '0'; 
          }
          return '1';
        });

        self.goodDisplay = ko.pureComputed(function () {
          if (self.good() != null) {
            return '' + formatNumber(self.good()) + '%'; 
          }
          return '';
        });

        self.fairDisplay = ko.pureComputed(function () {
          if (self.fair() != null) {
            return '' + formatNumber(self.fair()) + '%'; 
          }
          return '';
        });

        self.badDisplay = ko.pureComputed(function () {
          if (self.bad() != null) {
            return '' + formatNumber(self.bad()) + '%'; 
          }
          return '';
        });

        self.unknownDisplay = ko.pureComputed(function () {
          if (self.unknown() != null) {
            return '' + formatNumber(self.unknown()) + '%'; 
          }
          return '';
        });

        self.goodRawDisplay = ko.pureComputed(function () {
          if (self.good() != null) {
            return '<i class=\'fas fa-check-circle semantic-good\'></i> Good ' + formatRawNumber(self.good()) + '%'; 
          }
          return '';
        });

        self.fairRawDisplay = ko.pureComputed(function () {
          if (self.fair() != null) {
            return '<i class=\'fas fa-minus-circle semantic-fair\'></i> Fair ' + formatRawNumber(self.fair()) + '%'; 
          }
          return '';
        });

        self.badRawDisplay = ko.pureComputed(function () {
          if (self.bad() != null) {
            return '<i class=\'fas fa-exclamation-circle semantic-bad\'></i> Bad ' + formatRawNumber(self.bad()) + '%'; 
          }
          return '';
        });

        self.unknownRawDisplay = ko.pureComputed(function () {
          if (self.unknown() != null) {
            return '<i class=\'fas fa-question-circle semantic-unknown\'></i> Unknown ' + formatRawNumber(self.unknown()) + '%';
          }
          return '';
        });

        self.qualityClass = ko.pureComputed(function () {
            switch (self.currentQuality()) {
                case 'GOOD': return 'general-status-semantic-good';
                case 'BAD': return 'general-status-semantic-bad';
                case 'FAIR': return 'general-status-semantic-fair';
                default: return 'general-status-semantic-unknown';
            }
        });

        self.qualityText = ko.pureComputed(function () {
            switch (self.currentQuality()) {
                case 'GOOD': return 'GOOD';
                case 'BAD': return 'BAD';
                case 'FAIR': return 'FAIR';
                case 'UNKNOWN': return 'UNKNOWN';
                default: return '';
            }
        });

        self.getQualityClass = ko.pureComputed(function () {
            switch (self.currentQuality()) {
                case 'GOOD': return 'fa-check-circle';
                case 'BAD': return 'fa-exclamation-circle';
                case 'FAIR': return 'fa-minus-circle';
                case 'UNKNOWN': return 'fa-question-circle';
                default: return '';
            }
        });

        self.getLiveQualityClass = ko.pureComputed(function () {
            switch (self.quality()) {
                case 'GOOD': return 'fa-check-circle semantic-good';
                case 'BAD': return 'fa-exclamation-circle semantic-bad';
                case 'FAIR': return 'fa-minus-circle semantic-fair';
                case 'UNKNOWN': return 'fa-question-circle semantic-unknown';
                default: return '';
            }
        });

      self.isLive = ko.pureComputed(function () {
          return !self.endTimeRaw();
        });

        self.getCallTypeClass = ko.pureComputed(function () {
            switch (self.callType().toLowerCase()) {
                case 'video': return 'fa-camera-web';
                case 'audio': return 'fa-volume';
                case 'control': return 'fa-project-diagram';
                default: return 'fa-tv-alt';
            }
        });

        self.callStatusText = ko.pureComputed(function () {
            if (self.endTimeRaw()) {
                return "Call<br>Ended";
            } else {
                return "Call<br>in Progress";
            }
        });

        self.sourceImage = ko.pureComputed(function () {
            return getLogoImage(self.dataSource());
        });

        self.hasCdrhData = ko.observable();
        self.hasCmrData = ko.observable();
        self.hasCdrData = ko.observable();

        self.callCDRHCss = ko.pureComputed(function () {
            return self.recordsUpdated() && self.hasCdrhData() ? '' : 'call-element-hidden';
        });
        self.callCMRCss = ko.pureComputed(function () {
            return self.recordsUpdated() && self.hasCmrData() ? self.hasCdrData() ? 'col-lg-6 col-md-6 col-sm-12 col-xs-12' : 'col-lg-12 col-md-12 col-sm-12 col-xs-12' : 'call-element-hidden';
        });
        self.callCDRCss = ko.pureComputed(function () {
            return self.recordsUpdated() && self.hasCdrData() ? self.hasCmrData() ? 'col-lg-6 col-md-6 col-sm-12 col-xs-12' : 'col-lg-12 col-md-12 col-sm-12 col-xs-12' : 'call-element-hidden';
        });
        self.omniFilter = ko.observable('');

        self.filterFunction = function (data) {
            return self.filterResults[data.id];
        };

        self.callChartsCss = ko.pureComputed(function () {
            return self.qualityDetailsUpdated() ? '' : 'call-element-hidden';
        });

        self.sourceIpCss = ko.pureComputed(function () {
            return 'empty' === self.sourceIp() ? 'call-element-hidden ip' : 'ip';
        });

        self.targetIpCss = ko.pureComputed(function () {
            return 'empty' === self.targetIp() ? 'call-element-hidden ip' : 'ip';
        });

        self.hasPacketLossData = ko.observable(false);
        self.packetLossCss = ko.pureComputed(function () {
            return !self.hasPacketLossData() ? 'call-element-hidden assurance-call-details-chart-container' : 'assurance-call-details-chart-container';
        });
        
        self.hasQotData = ko.observable(false);
        self.qotCss = ko.pureComputed(function () {
            return !self.hasQotData() ? 'call-element-hidden assurance-call-details-chart-container' : 'assurance-call-details-chart-container';
        });
        self.showQotHeader = ko.observable(true);
        self.qotHeaderCss = ko.pureComputed(function () {
            return !self.showQotHeader() ? 'call-element-hidden' : '';
        });
        self.hasJitterData = ko.observable(false);
        self.jitterCss = ko.pureComputed(function () {
            return !self.hasJitterData() ? 'call-element-hidden assurance-call-details-chart-container' : 'assurance-call-details-chart-container';
        });

        self.hasChannelBitrateData = ko.observable(false);
        self.channelBitrateCss = ko.pureComputed(function () {
            return !self.hasChannelBitrateData() ? 'call-element-hidden assurance-call-details-chart-container' : 'assurance-call-details-chart-container';
        });

        self.hasLatencyData = ko.observable(false);
        self.latencyCss = ko.pureComputed(function () {
            return !self.hasLatencyData() ? 'call-element-hidden assurance-call-details-chart-container' : 'assurance-call-details-chart-container';
        });

        self.hasResolutionData = ko.observable(false);
        self.resolutionCss = ko.pureComputed(function () {
            return !self.hasResolutionData() ? 'call-element-hidden assurance-call-details-chart-container' : 'assurance-call-details-chart-container';
        });

        self.hasFramerateData = ko.observable(false);
        self.framerateCss = ko.pureComputed(function () {
            return !self.hasFramerateData() ? 'call-element-hidden assurance-call-details-chart-container' : 'assurance-call-details-chart-container';
        });

        self.hasCpuData = ko.observable(false);
        self.cpuCss = ko.pureComputed(function () {
            return !self.hasCpuData() ? 'call-element-hidden assurance-call-details-chart-container' : 'assurance-call-details-chart-container';
        });

        self.observer = new MutationObserver(function(mutationsList, observer) {
            if (self.recordsUpdated()) {
                if (self.cdrTable) {
                    self.cdrTable.redraw(true);
                }
                if (self.cmrTable) {
                    self.cmrTable.redraw(true);
                }
            }
        });
        self.observer.observe(document.querySelector('#call-details-tables'), {
            attributes: true
        });



        self.protocol = ko.observable();
        self.protocolAudio = ko.observable();
        self.protocolVideo = ko.observable();
        self.protocolPresentation = ko.observable();
        self.bitrate = ko.observable();
        self.mediaRouted = ko.observable();
        self.presentation = ko.observable();

        self.callType = ko.observable();
        self.mos = ko.observable();
        self.deviceType = ko.observable();
        self.platform = ko.observable();
        self.platformVersionBR = ko.observable();
        self.version = ko.observable();
        self.connection = ko.observable();
        self.mediaNode = ko.observable();
        self.disconnectReason = ko.observable();
        self.disconnectDetails = ko.observable();
        self.localIP = ko.observable();
        self.publicIP = ko.observable();
        self.audioCodecTx = ko.observable();
        self.audioCodecRx = ko.observable();
        self.videoCodecTx = ko.observable();
        self.videoCodecRx = ko.observable();
        self.presentationCodecTx = ko.observable();
        self.presentationCodecRx = ko.observable();
        self.audioCodecHtml = ko.observable();
        self.videoCodecHtml = ko.observable();
        self.presentationCodecHtml = ko.observable();
        self.perfCamera = ko.observable();
        self.perfMicrophone = ko.observable();
        self.perfSpeaker = ko.observable();

        self.roomName = ko.observable();
        self.roomFloor = ko.observable();
        self.roomType = ko.observable();
        self.roomEndpointType = ko.observable();
        self.buildingKey = ko.observable();
        self.buildingName = ko.observable();
        self.buildingRegion = ko.observable();
        self.buildingCountry = ko.observable();
        self.buildingState = ko.observable();
        self.buildingCity = ko.observable();
        self.buildingSite = ko.observable();
        self.networkName = ko.observable();
        self.networkIp = ko.observable();



        self.endpointId = ko.observable();
        self.endpointName = ko.observable();
        self.microphone = ko.observable();
        self.camera = ko.observable();
        self.touchPanel = ko.observable();
        self.display = ko.observable();
        self.deviceInfos = ko.observable([]);

        
        self.sourceIPURL = ko.pureComputed(function () {
            if (self.sourceIp()) {
                return 'https://{}'.replace('{}', self.sourceIp());
            } else {
                return '';
            }
        });
        self.sourceURL = ko.pureComputed(function () {
            if (self.endpointName()) {
                return '#monitoring/endpoints/{}/tabid/0'.replace('{}', self.endpointId());
            } else {
                return '';
            }
        });

        self.targetIPURL = ko.pureComputed(function () {
            if (self.targetIp()) {
                return 'https://{}'.replace('{}', self.targetIp());
            } else {
                return '';
            }
        });

        self.meetingURL = ko.pureComputed(function () {
            if (self.meetingId()) {
                return '#monitoring/meetings?filter={}'.replace('{}', encodeURIComponent('meeting_id==' + self.meetingId()));
            } else {
                return '';
            }
        });


        self.targetIpOrMeetingName = ko.pureComputed(function () {
            if (_.isEmpty(self.meetingName()) || _.isEmpty(self.meetingId())) {
                return self.targetIp();
            } else {
                return self.meetingName();
            }
        });
        self.targetIpOrMeetingNameVisible = ko.pureComputed(function () {
            if (_.isEmpty(self.meetingName()) || _.isEmpty(self.meetingId())) {
                return self.targetIp() && self.targetIp() !== 'empty';
            } else {
                return true;
            }
        });
        self.targetIpOrMeetingURL = ko.pureComputed(function () {
            if (_.isEmpty(self.meetingName()) || _.isEmpty(self.meetingId())) {
                return self.targetIPURL();
            } else {
                return self.meetingURL();
            }
        });


        function loadInitialData() {
            if (self.recordsUpdated()) {
                self.loadCDRData();
            }
            if (self.qualityDetailsUpdated()) {
                self.loadInitialChartData();
            }
        }
        self.myView = self.route().view;

        self.routeSubscription = self.route.subscribe(function() {
            if (self.route().view === self.myView) {
                self.cleanupSubscriptions();
                // todo WIP show loading on summary
                self.loadSummaryData().then(function () {
                    loadInitialData();
                });
            }
        });


        Highcharts.setOptions({
            lang:{
                rangeSelectorZoom:'',
            }
        });

        DataProvider.getInstance().fetchAssuranceQueryServiceBaseURL()
            .then(function (baseUrl) {
                self.baseV1Url = baseUrl;
                DataProvider.getInstance().fetchAssuranceQueryServiceV2BaseURL()
                    .then(function (baseUrl) {
                        self.baseUrl = baseUrl;
                        // TODO: Why is this called again? We already set self.baseUrlV1 above
                        DataProvider.getInstance().fetchAssuranceQueryServiceBaseURL()
                            .then(function (baseUrlV1) {
                                self.baseUrlV1 = baseUrlV1;
                                DataProvider.getInstance().fetchAssuranceAlertConfigServiceBaseURL()
                                    .then(function (baseUrlV1Alert) {
                                        self.baseUrlV1Alert = baseUrlV1Alert;
                                        self.loadQualityThresholds().then( function (thresholds) {
                                          self.thresholds = thresholds;

                                          DataService
                                            .fetchCallRecordsMetadata()
                                            .then(function (metadata) {
                                              self.callRecordMetadata = metadata;
                                              var packetLossSeriesOptions = [
                                                {
                                                  name: 'Audio (Send)',
                                                  colorIndex: 0,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'audio',
                                                    metric: 'packet_loss_rate',
                                                  },
                                                }, {
                                                  name: 'Audio (Receive)',
                                                  colorIndex: 1,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'audio',
                                                    metric: 'packet_loss_rate',
                                                  },
                                                }, {
                                                  name: 'Video (Send)',
                                                  colorIndex: 2,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'video',
                                                    metric: 'packet_loss_rate',
                                                  },
                                                }, {
                                                  name: 'Video (Receive)',
                                                  colorIndex: 3,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'video',
                                                    metric: 'packet_loss_rate',
                                                  },
                                                }, {
                                                  name: 'Presentation (Send)',
                                                  colorIndex: 4,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'presentation',
                                                    metric: 'packet_loss_rate',
                                                  },
                                                }, {
                                                  name: 'Presentation (Receive)',
                                                  colorIndex: 5,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'presentation',
                                                    metric: 'packet_loss_rate',
                                                  },
                                                },
                                              ];
                                              var jitterSeriesOptions = [
                                                {
                                                  name: 'Audio (Send)',
                                                  colorIndex: 0,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'audio',
                                                    metric: 'jitter',
                                                  },
                                                }, {
                                                  name: 'Audio (Receive)',
                                                  colorIndex: 1,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'audio',
                                                    metric: 'jitter',
                                                  },
                                                }, {
                                                  name: 'Video (Send)',
                                                  colorIndex: 2,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'video',
                                                    metric: 'jitter',
                                                  },
                                                }, {
                                                  name: 'Video (Receive)',
                                                  colorIndex: 3,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'video',
                                                    metric: 'jitter',
                                                  },
                                                }, {
                                                  name: 'Presentation (Send)',
                                                  colorIndex: 4,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'presentation',
                                                    metric: 'jitter',
                                                  },
                                                }, {
                                                  name: 'Presentation (Receive)',
                                                  colorIndex: 5,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'presentation',
                                                    metric: 'jitter',
                                                  },
                                                },
                                              ];
                                              var channelBitrateSeriesOptions = [
                                                {
                                                  name: 'Audio (Send)',
                                                  colorIndex: 0,
                                                }, {
                                                  name: 'Audio (Receive)',
                                                  colorIndex: 1,
                                                }, {
                                                  name: 'Video (Send)',
                                                  colorIndex: 2,
                                                }, {
                                                  name: 'Video (Receive)',
                                                  colorIndex: 3,
                                                }, {
                                                  name: 'Presentation (Send)',
                                                  colorIndex: 4,
                                                }, {
                                                  name: 'Presentation (Receive)',
                                                  colorIndex: 5,
                                                },
                                              ];
                                              var framerateSeriesOptions = [
                                                {
                                                  name: 'Audio (Send)',
                                                  colorIndex: 0,
                                                  visible: false,
                                                }, {
                                                  name: 'Audio (Receive)',
                                                  colorIndex: 1,
                                                  visible: false,
                                                }, {
                                                  name: 'Video (Send)',
                                                  colorIndex: 2,
                                                }, {
                                                  name: 'Video (Receive)',
                                                  colorIndex: 3,
                                                }, {
                                                  name: 'Presentation (Send)',
                                                  colorIndex: 4,
                                                }, {
                                                  name: 'Presentation (Receive)',
                                                  colorIndex: 5,
                                                },
                                              ];
                                              var cpuSeriesOptions = [
                                                {
                                                  name: 'App',
                                                  colorIndex: 7,
                                                }, {
                                                  name: 'System',
                                                  colorIndex: 18,
                                                },
                                              ];
                                              var latencySeriesOptions = [
                                                {
                                                  name: 'Audio (Send)',
                                                  colorIndex: 0,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'audio',
                                                    metric: 'latency',
                                                  },
                                                }, {
                                                  name: 'Audio (Receive)',
                                                  colorIndex: 1,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'audio',
                                                    metric: 'latency',
                                                  },
                                                }, {
                                                  name: 'Video (Send)',
                                                  colorIndex: 2,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'video',
                                                    metric: 'latency',
                                                  },
                                                }, {
                                                  name: 'Video (Receive)',
                                                  colorIndex: 3,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'video',
                                                    metric: 'latency',
                                                  },
                                                }, {
                                                  name: 'Presentation (Send)',
                                                  colorIndex: 4,
                                                  custom: {
                                                    direction: 'tx',
                                                    type: 'presentation',
                                                    metric: 'latency',
                                                  },
                                                }, {
                                                  name: 'Presentation (Receive)',
                                                  colorIndex: 5,
                                                  custom: {
                                                    direction: 'rx',
                                                    type: 'presentation',
                                                    metric: 'latency',
                                                  },
                                                },
                                              ];
                                              var resolutionSeriesOptions = [
                                                {
                                                  name: 'Audio (Send)',
                                                  colorIndex: 0,
                                                  visible: false,
                                                }, {
                                                  name: 'Audio (Receive)',
                                                  colorIndex: 1,
                                                  visible: false,
                                                }, {
                                                  name: 'Video (Send)',
                                                  colorIndex: 2,
                                                }, {
                                                  name: 'Video (Receive)',
                                                  colorIndex: 3,
                                                }, {
                                                  name: 'Presentation (Send)',
                                                  colorIndex: 4,
                                                }, {
                                                  name: 'Presentation (Receive)',
                                                  colorIndex: 5,
                                                },
                                              ];
                                              var chartsSeriesOptions = [
                                                packetLossSeriesOptions,
                                                jitterSeriesOptions,
                                                channelBitrateSeriesOptions,
                                                framerateSeriesOptions,
                                                latencySeriesOptions,
                                                resolutionSeriesOptions,
                                                cpuSeriesOptions
                                              ];

                                              $.each(chartsSeriesOptions, function (j, seriesOptions) {
                                                $.each(seriesOptions, function (i, series) {
                                                  _.assign(series, {
                                                    data: [],
                                                    marker: {
                                                      radius: 3,
                                                      symbol: 'circle'
                                                    },
                                                    showInNavigator: true,
                                                    type: 'line',
                                                  });
                                                });
                                              });
                                              // cpuSeriesOptions[0].type = 'area';
                                              // cpuSeriesOptions[1].type = 'area';

                                              let qualityPointFormatter = function () {

                                                let icon = 'fas fa-question-circle semantic-neutral';
                                                let hcColor = 13;
                                                let qual = 'Unknown';

                                                function quality(v, good, bad) {
                                                  if (v < good) {
                                                    return 1; // good
                                                  }
                                                  if (v > bad) {
                                                    return 3; // bad
                                                  }
                                                  return 2; // fair
                                                }

                                                let custom = this.series.userOptions.custom;
                                                if (custom) {

                                                  let q = quality(this.y, self.thresholds.good.live[custom.direction][custom.type][custom.metric], self.thresholds.bad.live[custom.direction][custom.type][custom.metric]);

                                                  switch (q) {
                                                    case 1:
                                                      icon = 'fa-fw fas fa-check-circle semantic-good';
                                                      qual = 'Good';
                                                      hcColor = 12;
                                                      break;
                                                    case 2:
                                                      icon = 'fa-fw fas fa-minus-circle semantic-fair';
                                                      qual = 'Fair';
                                                      hcColor = 11;
                                                      break;
                                                    case 3:
                                                      icon = 'fa-fw fas fa-exclamation-circle semantic-bad';
                                                      qual = 'Bad';
                                                      hcColor = 10;
                                                      break;
                                                    case 4:
                                                      break;
                                                  }
                                                }
                                                
                                                const suffix = this.series.options.tooltip ? ( this.series.options.tooltip.valueSuffix) : '';
                                                return `<svg  style="color: ${this.color}" class="highcharts-color-${this.series.colorIndex}" width="10" height="10"><circle cx="5" cy="5" r="4"/></svg>`+
                                                  ` ${this.series.name}: <b>${formatRawNumber(this.y)}${suffix}</b> ` +
                                                  `<span style="margin-top:3px;"><i class="${icon} highcharts-color-${hcColor}"></i> ${qual}</span><br/>`;

                                              };

                                              $.each(packetLossSeriesOptions, function (i, series) {
                                                _.assign(series, {
                                                  tooltip: {
                                                    valueDecimals: 1,
                                                    valueSuffix: '%',
                                                  },
                                                });
                                              });

                                              $.each(cpuSeriesOptions, function (i, series) {
                                                _.assign(series, {
                                                  tooltip: {
                                                    valueDecimals: 0,
                                                    valueSuffix: '%',
                                                  },
                                                });
                                              });

                                              $.each(jitterSeriesOptions, function (i, series) {
                                                _.assign(series, {
                                                  tooltip: {
                                                    valueDecimals: 0,
                                                    valueSuffix: ' ms',
                                                  },
                                                });
                                              });
                                              $.each(channelBitrateSeriesOptions, function (i, series) {
                                                _.assign(series, {
                                                  tooltip: {
                                                    pointFormatter: function () {
                                                      return '<span class="highcharts-color-' + this.colorIndex + '">' +
                                                        '\u25CF</span> ' + this.series.name + ': <span class="highcharts-strong">' +
                                                        getReadableBitrateString(this.y) +
                                                        '</span><br/>';
                                                    },
                                                  },
                                                });
                                              });
                                              $.each(framerateSeriesOptions, function (i, series) {
                                                _.assign(series, {
                                                  tooltip: {
                                                    valueDecimals: 1,
                                                    valueSuffix: ' fps',
                                                  },
                                                });
                                              });
                                              $.each(latencySeriesOptions, function (i, series) {
                                                _.assign(series, {
                                                  tooltip: {
                                                    valueDecimals: 0,
                                                    valueSuffix: ' ms',
                                                  },
                                                });
                                              });
                                              $.each(resolutionSeriesOptions, function (i, series) {
                                                _.assign(series, {
                                                  tooltip: {
                                                    valueDecimals: 0,
                                                    valueSuffix: 'p', // todo X x Y i.e. 1920x1080
                                                  },
                                                });
                                              });

                                              var qotChartData = _.merge({},
                                                {
                                                  showInNavigator: true,
                                                  title: undefined,
                                                  subtitle: undefined,
                                                  legend: {
                                                    enabled: false // This removes the legend
                                                  },
                                                  credits: {
                                                    enabled: false
                                                  },
                                                  exporting: {
                                                    buttons: {
                                                      contextButton: {
                                                        enabled: false
                                                      }
                                                    }
                                                  },
                                                  chart: {
                                                    backgroundColor: '#FF00FF',
                                                    type: 'line',

                                                    styledMode: true,
                                                    zoomType: 'x', // let the user select to zoom
                                                    panning: true, // keep panning enabled, but use shift to pan
                                                    panKey: 'shift',

                                                    zooming: {
                                                      type: 'x',
                                                      resetButton: {
                                                        position: {
                                                          x: 0,
                                                          y: -300 // move it outside the chart
                                                        }
                                                      }
                                                    },
                                                    plotBorderWidth: 0,
                                                    borderWidth: 0,
                                                    spacing: [0, 0, 0, 0],
                                                    margin: [0, 10, 30, 10],
                                                    // resizeDebounce: 0,
                                                    events: {
                                                      load() {
                                                        const qotContainer = document.querySelectorAll('#call-details-chart-qot.assurance-call-details-chart-container');
                                                        const observer2 = new ResizeObserver((entries) => {
                                                          for (let entry of entries) {
                                                            self.qotChart.reflow(); // todo this sometime causes the end to be cutoff???
                                                            self.qotChart.setSize(void 0, void 0, false); // todo this sometime causes the end to be cutoff???
                                                          }
                                                        });
                                                        qotContainer.forEach(el => {
                                                          observer2.observe(el);
                                                        });
                                                      },
                                                      render() {
                                                        // clip the graph to have rounded edges
                                                        let newWidth = this.plotSizeX;
                                                        const chart = this;

                                                        // Remove existing custom clip path if recreating
                                                        if (chart.customClipPath) {
                                                          chart.customClipPath.destroy();
                                                        }

                                                        chart.customClipPath = chart.renderer.createElement('clipPath')
                                                          .attr({id: 'custom-plot-clip'})
                                                          .add(chart.renderer.defs);

                                                        chart.renderer.path()
                                                          .attr({
                                                            d: [['m', 14, 6], ['a', 4, 4, 0, 0, 0, 0, 8], ['h', newWidth - 9], ['a', 4, 4, 0, 0, 0, 0, -8], ['z']]
                                                          })
                                                          .add(chart.customClipPath);

                                                        if (chart.xAxis[0].plotLinesAndBandsGroups['bands-0']) {
                                                          chart.xAxis[0].plotLinesAndBandsGroups['bands-0'].attr({
                                                            'clip-path': `url(#custom-plot-clip)`
                                                          });
                                                        }
                                                      }

                                                    }
                                                  },

                                                  lang: {
                                                    noData: null
                                                  },

                                                  xAxis: {
                                                    margin: 0,
                                                    minPadding: 0,
                                                    maxPadding: 0,
                                                    type: 'datetime',
                                                    ordinal: false,
                                                    minRange: 30000,
                                                    visible: true,
                                                    crosshair: true,
                                                    events: {
                                                      setExtremes: function (e) {
                                                        self.doSyncExtremes(e, this.chart);
                                                      },
                                                    },
                                                  },
                                                  yAxis: {
                                                    min: 0, // todo remove
                                                    max: 14,

                                                    margin: 0,
                                                    minPadding: 0,
                                                    maxPadding: 0,
                                                    offset: 0,
                                                    labels: {
                                                      enabled: false
                                                    },
                                                    visible: false, // Hides the entire y-axis
                                                    borderWidth: 0, // Removes the outer border [9]
                                                    plotBorderWidth: 0, // Removes the plot area border [9]
                                                    spacingTop: 0, // Optionally remove extra spacing
                                                    spacingBottom: 0
                                                  },
                                                  tooltip: {
                                                    followPointer: false,
                                                    split: false,
                                                    dateTimeLabelFormats: {
                                                      millisecond: "%a, %b %e, %H:%M:%S",
                                                    },

                                                    outside: true,
                                                    shape: 'callout', // Activates the arrow shape
                                                    useHTML: true, // Enables full HTML rendering
                                                    padding: 3, // Clears default SVG padding to let CSS handle it

                                                    pointFormatter: function () {
                                                      let ms = this.z;

                                                      let hours = Math.floor(ms / 3600000);
                                                      let minutes = Math.floor((ms % 3600000) / 60000);
                                                      let seconds = Math.floor((ms % 60000) / 1000);
                                                      let millis = Math.floor((ms % 1000));

                                                      let durationString = '';
                                                      if (hours > 0) durationString += `${hours}h `;
                                                      if (minutes > 0 || hours > 0) durationString += `${minutes}m `;
                                                      if (seconds > 0 || minutes > 0 || hours > 0) durationString += `${seconds}s`;
                                                      // if (millis) durationString += `${millis}ms`;
                                                      if (!durationString) {
                                                        durationString = '0s';
                                                      }

                                                      let icon = 'fa-circle';
                                                      switch (this.series.name.toUpperCase().slice(0, 3)) {
                                                        case 'GOO':
                                                          icon = 'fas fa-check-circle semantic-good';
                                                          break;
                                                        case 'FAI':
                                                          icon = 'fas fa-minus-circle semantic-fair';
                                                          break;
                                                        case 'BAD':
                                                          icon = 'fas fa-exclamation-circle semantic-bad';
                                                          break;
                                                        case 'UNK':
                                                          icon = 'fas fa-question-circle semantic-neutral';
                                                          break;
                                                      }

                                                      return `<i class="${icon} highcharts-color-${this.series.colorIndex}"></i> ${this.series.name}<br>`;
                                                    },

                                                    positioner: function (labelWidth, labelHeight, point) {
                                                      // position tooltip below chart
                                                      // Return absolute coordinates relative to the chart
                                                      return {
                                                        x: point.plotX + this.chart.plotLeft - (labelWidth / 2), // if I do -10 it's closer to what I want, but the arrow is off center
                                                        y: this.chart.plotTop + point.plotY + (labelHeight / 2)
                                                      };
                                                    }

                                                  },

                                                  plotOptions: {
                                                    line: {
                                                      animation: false,
                                                    },

                                                    series: {
                                                      lineWidth: 0,
                                                      marker: {
                                                        enabled: false,
                                                        radius: 3.5,
                                                        symbol: 'circle'
                                                      },
                                                      states: {
                                                        hover: {
                                                          marker: {
                                                            fill: '#ffffff',
                                                          },
                                                        },
                                                      },
                                                      borderColor: null,
                                                      groupPadding: 0,
                                                      pointPadding: 0,
                                                      point: {
                                                        events: {
                                                          mouseOver: self.getMouseOver()
                                                        }
                                                      },
                                                      events: {
                                                        mouseOut: self.getMouseOut()
                                                      }

                                                    },
                                                  },
                                                  series: [
                                                    {
                                                      colorIndex: 12,
                                                      name: 'Good',
                                                      data: [],
                                                      groupPadding: 0,
                                                      pointPadding: 0,
                                                      borderWidth: 0,
                                                      clip: false,
                                                    },
                                                    {
                                                      colorIndex: 11,
                                                      name: 'Fair',
                                                      data: [],
                                                      groupPadding: 0,
                                                      pointPadding: 0,
                                                      borderWidth: 0,
                                                      clip: false,
                                                    },
                                                    {
                                                      name: 'Bad',
                                                      colorIndex: 10,
                                                      data: [],
                                                      groupPadding: 0,
                                                      pointPadding: 0,
                                                      borderWidth: 0,
                                                      clip: false,
                                                    },
                                                    {
                                                      name: 'Unknown',
                                                      colorIndex: 13,
                                                      data: [],
                                                      groupPadding: 0,
                                                      pointPadding: 0,
                                                      borderWidth: 0,
                                                      clip: false,
                                                    },

                                                  ],
                                                  scrollbar: { // todo WIP need to be enabled for smooth pan, but can't quite get it to completely hide
                                                    height: 0,
                                                    margin: 0,

                                                  },
                                                  rangeSelector: {
                                                    enabled: false,
                                                  },
                                                  time: {
                                                    useUTC: false,
                                                  },
                                                  navigator: {
                                                    enabled: false,
                                                  },
                                                });

                                              var packetLossChartData = {
                                                series: packetLossSeriesOptions,
                                                title: {
                                                  text: 'Packet Loss',
                                                },
                                                yAxis: {
                                                  labels: {
                                                    format: '{value} %',
                                                  },
                                                  floor: 0,
                                                  // ceiling: 100,
                                                  min: 0, // todo remove
                                                  softMax: 5,
                                                  minRange: 1,
                                                  opposite: false,
                                                  showLastLabel: true,
                                                  tickAmount: 6,
                                                },
                                              };

                                              var jitterChartData = {
                                                series: jitterSeriesOptions,
                                                title: {
                                                  text: 'Jitter',
                                                },
                                                yAxis: {
                                                  labels: {
                                                    format: '{value} ms',
                                                  },
                                                  floor: 0,
                                                  // ceiling: 1000,
                                                  min: 0, // todo remove
                                                  softMax: 50,
                                                  minRange: 5,
                                                  opposite: false,
                                                  showLastLabel: true,
                                                  tickAmount: 6,
                                                },
                                              };

                                              var channelBitrateChartData = {
                                                series: channelBitrateSeriesOptions,
                                                title: {
                                                  text: 'Channel Bitrate',
                                                },
                                                yAxis: {
                                                  labels: {
                                                    formatter: function () {
                                                      return getReadableBitrateString(this.value);
                                                    },
                                                  },
                                                  // type: 'logarithmic',
                                                  floor: 0,
                                                  minRange: 1,
                                                  min: 0, // todo remove
                                                  opposite: false,
                                                  showLastLabel: true,
                                                  tickAmount: 6,
                                                },
                                              };

                                              var framerateChartData = {
                                                series: framerateSeriesOptions,
                                                title: {
                                                  text: 'Framerate',
                                                },
                                                yAxis: {
                                                  labels: {
                                                    format: '{value} fps',
                                                  },
                                                  floor: 0,
                                                  // ceiling: 120,
                                                  minRange: 15,
                                                  min: 0, // todo remove
                                                  opposite: false,
                                                  showLastLabel: true,
                                                  tickAmount: 5,
                                                },
                                              };

                                              var cpuChartData = {
                                                series: cpuSeriesOptions,
                                                title: {
                                                  text: 'CPU',
                                                },
                                                yAxis: {
                                                  labels: {
                                                    format: '{value} %',
                                                  },
                                                  floor: 0,
                                                  ceiling: 100,
                                                  min: 0,
                                                  max: 100,
                                                  opposite: false,
                                                  showLastLabel: true,
                                                  tickAmount: 5,
                                                },
                                              };

                                              // WIP
                                              var latencyChartData = {
                                                series: latencySeriesOptions,
                                                title: {
                                                  text: 'Latency',
                                                },
                                                yAxis: {
                                                  labels: {
                                                    // align: 'left',
                                                    // x: 2,
                                                    // y: -2,
                                                    format: '{value} ms',
                                                  },
                                                  floor: 0,
                                                  // ceiling: 1000,
                                                  min: 0, // todo remove
                                                  softMax: 50,
                                                  opposite: false,
                                                  showLastLabel: true,
                                                  tickAmount: 6,
                                                },
                                              };

                                              // WIP
                                              var resolutionChartData = {
                                                series: resolutionSeriesOptions,
                                                title: {
                                                  text: 'Resolution',
                                                },
                                                yAxis: {
                                                  // type: 'logarithmic',
                                                  labels: {
                                                    format: '{value}p',
                                                  },
                                                  // tickPositions: [0, 180, 240, 360, 480, 576, 720, 1080, 1440, 2160, 2880],
                                                  tickPositions: [0, 180, 360, 480, 720, 1080],
                                                  // minRange: 720,
                                                  opposite: false,
                                                  showLastLabel: true,
                                                  min: 0, // todo remove
                                                },
                                              };

                                              $.each([packetLossChartData, channelBitrateChartData, jitterChartData, framerateChartData, latencyChartData,
                                                resolutionChartData, cpuChartData], function (i, chartData) {
                                                _.assign(chartData, {
                                                  chart: {
                                                    styledMode: true,
                                                    zoomType: 'x', // let the user select to zoom
                                                    panning: true, // keep panning enabled, but use shift to pan
                                                    panKey: 'shift',
                                                    // pinchType: 'x' // this didn't help prevent y zooming for mouse wheel
                                                    spacing: [0, 0, 0, 0],
                                                    height: 194,
                                                    marginLeft: 70,
                                                    marginRight: 20,
                                                  },

                                                  lang: {
                                                    noData: null
                                                  },

                                                  legend: {
                                                    enabled: false,
                                                    verticalAlign: 'top',
                                                    layout: 'vertical',
                                                    align: 'right',
                                                    backgroundColor: '#FFFFFF',
                                                    y: 20,
                                                    borderColor: 'black',
                                                    borderWidth: 1,
                                                  },

                                                  tooltip: {
                                                    followPointer: false,
                                                    split: false,
                                                    dateTimeLabelFormats: {
                                                      millisecond: "%a, %b %e, %H:%M:%S",
                                                    },
                                                  },

                                                  credits: {
                                                    enabled: false
                                                  },

                                                  plotOptions: {
                                                    series: {
                                                      gapSize: EXTERNAL_GAP_SIZE,
                                                      gapUnit: 'value',
                                                      dataGrouping: {
                                                        enabled: false,
                                                      },
                                                      label: {
                                                        enabled: false,
                                                      },
                                                      animation: false,
                                                      point: {
                                                        events: {
                                                          mouseOver: self.getMouseOver()
                                                        }
                                                      },
                                                      events: {
                                                        mouseOut: self.getMouseOut()
                                                      }
                                                    }
                                                  },

                                                  scrollbar: { // todo WIP need to be enabled for smooth pan, but can't quite get it to completely hide
                                                    height: 0,
                                                    margin: 0,

                                                  },

                                                  // WIP
                                                  // mapNavigation: { // enable mouse wheel zooming
                                                  //     enabled: true,
                                                  //     enableButtons: false,
                                                  //     enableDoubleClickZoom: false
                                                  // },

                                                  rangeSelector: {
                                                    enabled: false,
                                                    verticalAlign: 'bottom',
                                                    buttonPosition: {
                                                      align: 'left',
                                                      y: 4
                                                      // x: -35,
                                                    },
                                                    inputEnabled: false,
                                                    buttons: [{
                                                      type: 'minute',
                                                      count: 5,
                                                      text: '5m'
                                                    }, {
                                                      type: 'minute',
                                                      count: 15,
                                                      text: '15m'
                                                    }, {
                                                      type: 'minute',
                                                      count: 30,
                                                      text: '30m'
                                                    }, {
                                                      type: 'hour',
                                                      count: 1,
                                                      text: '1h'
                                                    }, {
                                                      type: 'all',
                                                      text: 'All'
                                                    }]
                                                  },

                                                  time: {
                                                    useUTC: false,
                                                  },


                                                  navigator: {
                                                    enabled: false,
                                                    labels: {
                                                      x: 3,
                                                      y: -20,
                                                    },
                                                    series: {
                                                      type: 'line',
                                                    },
                                                    height: 25,
                                                    margin: 10,
                                                  },
                                                  xAxis: {
                                                    type: 'datetime',
                                                    ordinal: false,
                                                    minRange: 30000,
                                                    events: {
                                                      setExtremes: function (e) {
                                                        self.doSyncExtremes(e, this.chart);
                                                      },
                                                    },
                                                  },
                                                });

                                                if (DataProvider.getInstance().isInternalUser()) {
                                                  _.merge(chartData, {
                                                    plotOptions: {
                                                      series: {
                                                        gapSize: INTERNAL_GAP_SIZE
                                                      }
                                                    }
                                                  });
                                                }
                                              });

                                              $.each([packetLossChartData, jitterChartData, latencyChartData], function (i, chartData) {
                                                _.merge(chartData, {
                                                  tooltip: {
                                                    useHTML: true, // Enables full HTML rendering
                                                    pointFormatter: qualityPointFormatter,
                                                  },
                                                });
                                              });
                                              $.each([packetLossChartData, jitterChartData, latencyChartData,
                                                cpuChartData], function (i, chartData) {
                                                _.merge(chartData, {

                                                  plotOptions: {
                                                    series: {
                                                      dataGrouping: {
                                                        approximation: 'high'
                                                      },
                                                    }
                                                  },

                                                });
                                              });

                                              $.each([channelBitrateChartData, framerateChartData,
                                                resolutionChartData], function (i, chartData) {
                                                _.merge(chartData, {

                                                  plotOptions: {
                                                    series: {
                                                      dataGrouping: {
                                                        approximation: 'low'
                                                      },
                                                    }
                                                  },

                                                });
                                              });

                                              cpuChartData.plotOptions.series.label.enabled = true;
                                              // cpuChartData.plotOptions.series.label.onArea = false;
                                              cpuChartData.plotOptions.series.label.style = {
                                                fontSize: '10px',
                                                fontWeight: 400
                                              };


                                              self.qotChart = Highcharts.chart('call-details-chart-qot', qotChartData); // todo stockChart

                                              self.packetLossChart = Highcharts.stockChart('call-details-chart-packet_loss_rate', packetLossChartData);
                                              self.channelBitrateChart = Highcharts.stockChart('call-details-chart-bitrate', channelBitrateChartData);

                                              self.jitterChart = Highcharts.stockChart('call-details-chart-jitter', jitterChartData);
                                              self.framerateChart = Highcharts.stockChart('call-details-chart-framerate', framerateChartData);
                                              self.cpuChart = Highcharts.stockChart('call-details-chart-cpu', cpuChartData);

                                              self.latencyChart = Highcharts.stockChart('call-details-chart-latency', latencyChartData);
                                              self.resolutionChart = Highcharts.stockChart('call-details-chart-resolution', resolutionChartData);

                                              self.charts = [self.packetLossChart, self.jitterChart, self.channelBitrateChart,
                                                self.framerateChart, self.latencyChart, self.resolutionChart];

                                              self.allCharts = [
                                                self.qotChart,
                                                self.packetLossChart, self.jitterChart, self.channelBitrateChart, self.framerateChart, self.latencyChart, self.resolutionChart, self.cpuChart];

                                              self.cmrTable = new Tabulator("#call-details-table-cmr", {
                                                layout: "fitDataFill",
                                                height: "calc(100vh - 249px)",
                                                minHeight: 200,
                                                placeholder: self.translationService.translate('noDataAvailable'),
                                                // virtualDom:false,
                                                clipboard: "copy",
                                                headerSortTristate: true,
                                                columnHeaderSortMulti: false,
                                              });
                                              self.cdrTable = new Tabulator("#call-details-table-cdr", {
                                                layout: "fitDataFill",
                                                height: "calc(100vh - 249px)",
                                                minHeight: 200,
                                                placeholder: self.translationService.translate('noDataAvailable'),
                                                // virtualDom:false,
                                                clipboard: "copy",
                                                headerSortTristate: true,
                                                columnHeaderSortMulti: false,
                                              });

                                              self.cdrhTable = new Tabulator("#call-details-table-cdrh", {
                                                layout: "fitColumns",
                                                height: "calc(100vh - 249px)",
                                                minHeight: 200,
                                                // height: false,
                                                placeholder: self.translationService.translate('noDataAvailable'),
                                                // virtualDom:false,
                                                clipboard: "copy",
                                                headerSortTristate: true,
                                                columnHeaderSortMulti: false,
                                                dataTree: true,
                                                dataTreeChildField: "_children",
                                                dataTreeStartExpanded: true, //start with an expanded tree
                                                dataTreeCollapseElement: "<i class='fas fa-caret-down tree-toggle'></i>",
                                                dataTreeExpandElement: "<i class='fas fa-caret-right tree-toggle'></i>",
                                                dataTreeBranchElement: false, // hide branch element
                                                dataTreeChildIndent: 14, //indent child rows by 12 (.tree-toggle icon width) + 3 (.tree-toggle icon padding) - 1 px
                                                rowFormatter: function (row) {
                                                  var data = row.getData();
                                                  if (row.getTreeChildren().length > 0) {
                                                    row.getElement().classList.add('tabulator-tree-level-x');
                                                  }
                                                },
                                                renderComplete: function () {
                                                  let headerMenuElement = $('#call-details-table-cdrh .tabulator-header-menu-button');
                                                  if (headerMenuElement && !headerMenuElement.hasClass('tabulator-header-menu-ellipsis-v')) {
                                                    headerMenuElement.addClass('tabulator-header-menu-ellipsis-v');
                                                    headerMenuElement.html('<i class="fas fa-ellipsis-v"></i>');
                                                  }
                                                },
                                              });


                                              self.showEmpty = ko.observable(false);
                                              self.showSummary = ko.observable(true);

                                              self.omniSubsciption = self.omniFilter.subscribe(val => {
                                                self.twoPassFilter();
                                              });

                                              self.showEmptySubsciption = self.showEmpty.subscribe(val => {
                                                self.twoPassFilter();
                                              });

                                              self.showSummarySubsciption = self.showSummary.subscribe(val => {
                                                self.twoPassFilter();
                                              });


                                              self.loadSummaryData().then(function () {
                                                loadInitialData();
                                              });

                                            });
                                        });
                                    });
                                });
                    });
            });

        self.thumbsUpClick = function(issue) {
            if (!issue.helpful()) {
                issue.helpful('up');
                self.dataProvider.logActivity2('thumbsUpClick', 'call-details-view.js', 'issue helpful' + issue.column);
            }
        };
        self.thumbsDownClick = function(issue) {
            if (!issue.helpful()) {
                issue.helpful('down');
                self.dataProvider.logActivity2('thumbsDownClick', 'call-details-view.js', 'issue not helpful' + issue.column);
            }
        };
    }

  koDescendantsComplete() {
    let self = this;
    const svgContainer = document.querySelectorAll('.pctSvg');

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        // Get the new width of the container/SVG
        const newWidth = entry.contentRect.width;

        // Calculate new x2 based on your requirements (e.g., subtracting padding)
        const offset = 5;
        const newX2 = newWidth - offset;

        // 3. Update the x2 attribute on the SVG line
        entry.target.children[0].setAttribute('x2', newX2);
      }
    });

    svgContainer.forEach(el => { observer.observe(el); });
    
  }

  hoverQuality(chartContainer, val, qualityClasses, percentClasses, data, event) {
    let self = data;

    let classList = document.getElementById(chartContainer).classList;
    qualityClasses.forEach((c) => classList.toggle(c));

    percentClasses.forEach( c => {
      let elementById = document.getElementById(c);
      if (elementById) {
        let classList = elementById.classList;
        classList.toggle('dim');
      }
    })
    
    if (val !== false) {
      // todo effect plot bands css
      self.qotChart.series.forEach((s, i) => {
        s.setState(i === val ? 'hover' : 'inactive');
      });
    } else {
      self.qotChart.series.forEach(s => {
        s.setState('');
      });

    }
  }
  hoverQualityPlotBands(chartContainer, val, qualityClasses, percentClasses, data, event) {
    let self = data;

    let classList = document.getElementById(chartContainer).classList;
    qualityClasses.forEach((c) => classList.toggle(c));
    }
  hoverSeries(val, data, event) {
    let self = data;
    if (val !== false) {
      self.charts.forEach(c => {
        if (c.series) {
          c.series.forEach((s, i) => {
            s.setState(val.includes(i) ? 'hover' : 'inactive');
          });
        }
      });
    } else {
      self.charts.forEach(c => {
        if (c.series) {
          c.series.forEach((s, i) => {
            s.setState('');
          });
        }
      });
    }
  }
  
  
  togglePlotBands(qualityClasses, shiftQualityClasses, altQualityClasses, data, event) {
    var self = data;
    if (event.shiftKey) {
      qualityClasses = shiftQualityClasses;
    } else if (event.altKey) {
      qualityClasses = altQualityClasses;
    }
    let classList = document.getElementById("call-details-charts").classList;
    qualityClasses.forEach((c) => classList.toggle(c));
  }
  
  toggleSeries(seriesIndicies, shiftSeriesIndicies, altSeriesIndicies, seriesElements, shiftSeriesElements, altSeriesElements, data, event) {
        var self = data;

        if (event.shiftKey) {
          seriesIndicies = shiftSeriesIndicies;
          seriesElements = shiftSeriesElements;
        } else 
        if (event.altKey) {
          seriesIndicies = altSeriesIndicies;
          seriesElements = altSeriesElements;
        }
        
        
        var _redraw = [];
        $.each(self.charts, function (m, chart) {
            _redraw[m] = chart.redraw;
            chart.redraw = function(){};
        });

        $.each(self.charts, function (m, chart) {
            $.each(seriesIndicies, function (n, index) {
                if ((chart !== self.framerateChart && chart !== self.resolutionChart ) || index > 1) {
                    chart.series[index].setVisible(!chart.series[index].visible);
                }
            });

        });

        seriesElements.forEach((e) => document.getElementById(e).classList.toggle('hide-quality-series'));
    
        $.each(self.charts, function (m, chart) {
            chart.redraw = _redraw[m];
        });

        $.each(self.charts, function (m, chart) {
            chart.redraw(true);
        });

        return true;
    }

    toggleShowEmpty(data, event) {
        var self = data;
        self.showEmpty(!self.showEmpty());
        return true;
    }

    toggleShowSummary(data, event) {
        var self = data;
        self.showSummary(!self.showSummary());
        return true;
    }

    downloadCDRHTableData(data, event) {
        var self = data;
        if (event.altKey) {
            self.downloadProgress = 0;
            let filename = 'callrecord-' + self.data().call_id + '.json.gz';
            WebResourceSecure.getBlob(self.baseV1Url + '/calls/' + self.data().call_id + '/' + self.data().start_time + '/callrecords/originalfile',
                                      undefined, 'GET', filename, function(evt){
                // console.log(evt.loaded, evt.total);
                // todo show progress in UI?
                if (evt.lengthComputable) {
                    self.downloadProgress = Math.floor(evt.loaded * 100 / evt.total) ;
                }
            }).then(function () {
                self.downloadDisabled = true;
            })
            return true;
        }
        // todo json xslx
        if (self.isCdrhTableFullyExpanded()) {
            self.cdrhTable.download('csv', self.data().start_time + '_' + self.source() + '-' + self.target() + '.csv');
        } else {
            CommonDialog
            .confirm('Download only exports expanded rows. Would you like to expand all rows before downloading?', 'Yes', 'No')
            .then(function (confirmed) {
                if (confirmed) {
                    self.expandCdrhTable(true);
                }
                self.cdrhTable.download('csv', self.data().start_time + '_' + self.source() + '-' + self.target() + '.csv');
            });
        }

        return true;
    }

    getMouseOver() {
        var self = this;
        return function (evt) {
            var targetPoint = evt.target;
            if (targetPoint) {
                var currentChart = targetPoint.series.chart;

                // find which xAxis the targetPoint is on (since there are multiple xAxis)
                var xAxisIndex = 0;
                for (; xAxisIndex < currentChart.xAxis.length; xAxisIndex++) {
                    if (targetPoint.series.xAxis === currentChart.xAxis[xAxisIndex]) {
                        break;
                    }
                }

                // find the series index for the targetPoint
                var allSeries = currentChart.series;
                for (var i = 0; i < allSeries.length; i++) {
                    if (allSeries[i] === targetPoint.series) {

                      var value = targetPoint.x;

                        // for every other chart
                        $.each(self.allCharts, function (k, aChart) {
                            if (aChart && currentChart !== aChart) {
                                // for the same xAxis
                                var aChartxAxis = aChart.xAxis[(aChart.xAxis.length > xAxisIndex) ? xAxisIndex : 0];
                                var newEvent = {
                                    chartX: aChartxAxis.toPixels(value),
                                    chartY: 0
                                };
                                var searchPoint;
                                if (aChart !== self.qotChart && aChart !== self.cpuChart) {
                                  // for the same series, if visible, find the point at the same x value
                                  if (aChart.series.length > i && aChart.series[i].visible) {
                                    searchPoint = aChart.series[i].searchPoint(newEvent, true);
                                  }
                                }
                                if (!searchPoint) { // if not visible or not found, find point at the same x value for any visible series
                                  let minDistance = Infinity;
                                  for (let j = 0; j < aChart.series.length; j++) {
                                        if (aChart.series[j].visible) {
                                            const point = aChart.series[j].searchPoint(newEvent, true); // todo special case for qot
                                            
                                            if (point && point.plotX !== undefined && point.plotY !== undefined) {
                                              // 4. Calculate the distance (Euclidean) from the event to the point
                                              const dx = newEvent.chartX - point.plotX;
                                              const dy = newEvent.chartY - point.plotY;
                                              const distance = Math.sqrt(dx * dx + dy * dy);
  
                                              // 5. Update if this targetPoint is the closest found so far
                                              if (distance < minDistance) {
                                                minDistance = distance;
                                                searchPoint = point;
                                              }
                                            }
                                        }
                                    }
                                }
                                
                                // there is some sort of bug in searchPoint
                                if (searchPoint && searchPoint.x !== targetPoint.x && aChart === self.qotChart) {
                                  // console.log('missed point:', targetPoint.x, searchPoint.x);
                                  for (let j = 0; j < aChart.series.length; j++) {
                                    let found = false;
                                    if (aChart.series[j].visible) {
                                      for (let k = 0; k < aChart.series[j].data.length; k++) {
                                        if (aChart.series[j].data[k].x === targetPoint.x) {
                                          searchPoint = aChart.series[j].points[k];
                                          // console.log('corrected point:', targetPoint.x, searchPoint.x);
                                          found = true;
                                          break;
                                        }
                                      }
                                      if (found) {
                                        break;
                                      }
                                    }
                                  }
                                }

                                if (self.lastSearchPoint && self.lastSearchPoint.x) {
                                    self.lastSearchPoint.setState();
                                    self.lastSearchPoint = null;
                                }

                                if (searchPoint && (aChart !== self.qotChart || self.showQotHeader())) {
                                    aChartxAxis.drawCrosshair(newEvent, searchPoint);
                                    searchPoint.setState('hover');
                                    aChart.tooltip.refresh(searchPoint);
                                    self.lastSearchPoint = searchPoint;
                                } else {
                                    aChart.tooltip.hide();
                                    $.each(aChart.xAxis, function (l, axis) {
                                        axis.hideCrosshair();
                                    });
                                }
                            }
                        });

                        break;
                    }
                }
            }
        };
    }

    getMouseOut() {
        var self = this;
        return function (evt) {
            $.each(self.allCharts, function (k, aChart) {
                if (evt.chart !== aChart) {
                    aChart.tooltip.hide();
                    if (self.lastSearchPoint && self.lastSearchPoint.x) {
                        self.lastSearchPoint.setState();
                        self.lastSearchPoint = null;
                    }
                    $.each(aChart.xAxis, function (l, axis) {
                        axis.hideCrosshair();
                    });
                }
            });
        };
    }

    doSyncExtremes(e, thisChart) {
        var self = this;

        if (e.trigger !== 'syncExtremes') {
          // there was some use case when e.min and e.max were not set and something wasn't doing the right thing
          // but on reset zoom it may need to be undefined
            if (!e.min) {
              e.min = thisChart.xAxis[0].dataMin;
            } 
            if(!e.max) {
              e.max = thisChart.xAxis[0].dataMax;
            }
            $.each(self.allCharts, function (k, chart) {
                if (chart !== thisChart) {
                    if (chart.xAxis[0].setExtremes) {
                        chart.xAxis[0].setExtremes(
                            e.min,
                            e.max,
                            true,
                            e.trigger === 'zoom' || e.trigger === 'rangeSelectorButton' || (e.trigger === 'navigator' && !e.triggerOp ),
                            { trigger: 'syncExtremes' }
                        );
                    }
                }
            });
        }
    }

    submitFeedback() {
      if (this.feedbackText() !== SENT_TEXT) {
        this.dataProvider.logActivity2('feedbackSubmit', 'call-details-view.js', this.feedbackText());
        this.feedbackText(SENT_TEXT);
      }
    }
    nothingWrongThumbsUpClick() {
      if (!this.nothingWrong()) {
        this.nothingWrong('up');
        this.dataProvider.logActivity2('thumbsUpClick', 'call-details-view.js', 'user confirms no issues');
      }
    }
    nothingWrongThumbsDownClick() {
      if (!this.nothingWrong()) {
        this.nothingWrong('down');
        this.dataProvider.logActivity2('thumbsUpClick', 'call-details-view.js', 'user reported something wrong when we did not');
      }
    }

    loadSummaryData() {
        var self = this;
        let url = self.baseUrl + '/calls/' + self.route().callId + '/' + self.route().startTime;
        if (self.route().uniqueId) {
            url = self.baseUrl + '/calls/' + window.encodeURIComponent(self.route().uniqueId);
        }
        return WebResourceSecure.getJSON(url).then(function (data) {
        // WebResource.getJSON('http://api.vyopta.com/cpmm/api/v1/orgs/1197calls/2018-09-20/2018-09-20T07:48:30.030Z/15').then(function (data) {
            self.data(data);
            self.source(data.source);
            self.target(data.target);
            self.meetingName(data.meeting_name);
            self.meetingId(data.meeting_id);
            self.dataSource(data.data_source);
            self.qualityDetailsUpdated(data.quality_details_updated);
            self.showDiagnostics = LoginService.userObject.smartDiagnostics && (self.dataSource()  === 'MSTEAMS CDR');
            self.recordsUpdated(data.call_records_updated);
            self.startTimeRaw(data.start_time);
            if (data.end_time === self.endTimeRaw() && !data.end_time) {
                self.endTimeRaw.valueHasMutated(); // todo WIP do this every second
            } else {
                self.endTimeRaw(data.end_time);
            }
            self.startDay(getReadableDay(self.startTimeRaw()));
            self.startYear(getReadableYear(self.startTimeRaw()));
            self.endDay(getReadableDay(self.endTimeRaw()));
            var readableTime = getReadableTime(self.startTimeRaw());
            if (readableTime) {
                readableTime += ' - ';
            }
            self.startTime(readableTime);
            self.endTime(getReadableTime(self.endTimeRaw(), self.startTimeRaw()));
            self.quality(data.quality);
            self.avgQuality(data.avg_quality);
            
            self.good(data.pct_good_quality);
            self.fair(data.pct_fair_quality);
            self.bad(data.pct_bad_quality);
            self.unknown(data.pct_unknown_quality);

            self.protocol(data.protocol);
            self.bitrate(getReadableBitrateString(data.bitrate));
            self.mediaRouted(getMediaRoutedVal(data.data_source, data.media_routed));
            self.presentation(data.presentation);

            self.callType(data.call_type);
            if (data.mos !== undefined && data.mos !== null) {
                let value = parseFloat(data.mos);
                if (value === -2.0) {
                    self.mos('Invalid');
                } else if (value === -1.0) {
                    self.mos('');
                } else {
                    self.mos('' + data.mos);
                }
            } else {
                self.mos('');
            }
            self.deviceType(data.device_type);
            self.platform(data.device_platform);
            let pvBR = '';
            if (data.device_platform && data.device_version) pvBR = '<br>';
            self.platformVersionBR(pvBR);
            self.version(data.device_version);
            self.connection(data.connection_type);
            self.mediaNode(data.media_node);
            self.disconnectDetails(data.disconnect_details);
            self.disconnectReason(data.disconnect_reason);
            self.localIP(data.local_ip);
            self.publicIP(data.public_ip);
            // self.audioCodecTx(data.);
            // self.audioCodecRx(data.);
            // self.videoCodecTx(data.);
            // self.videoCodecRx(data.);
            // self.presentationCodecTx(data.);
            // self.presentationCodecRx(data.);
            self.perfCamera(data.camera);
            self.perfMicrophone(data.microphone);
            self.perfSpeaker(data.speaker);

            self.roomName(data.room_name);
            self.roomFloor(data.room_floor);
            self.roomType(data.room_type);
            self.roomEndpointType(data.room_endpoint_type);
            self.buildingKey(data.building_key);
            self.buildingName(data.building_name);
            self.buildingRegion(data.building_region);
            self.buildingCountry(data.building_country);
            self.buildingState(data.building_state);
            self.buildingCity(data.building_city);
            self.buildingSite(data.building_site);
            self.networkName(data.network_name);
            self.networkIp(data.network_ip);

            self.endpointId(data.endpoint_id);
            self.endpointName(data.endpoint_name);
            //todo WIP set the chart x axis soft min to start and soft max to end every second
            // $.each(self.chart.xAxis, function (i, axis) { // todo this isn't having any effect
            //   axis.softMin = getTime(self.startTimeRaw());
            //   axis.softMax = getTime(self.endTimeRaw());
            // });

            // $.each(self.charts, function (k, chart) {
            //     $.each(chart.xAxis, function (a, axis) {
            //         axis.min = getTime(self.startTimeRaw()) + 1000*60*4;
            //         axis.floor = getTime(self.startTimeRaw()) + 1000*60*4;
            //         axis.ceiling = getTime(self.endTimeRaw());
            //         axis.max = getTime(self.endTimeRaw());
            //     });
            // });
            if (self.qualityDetailsUpdated()) {
                self.loadLatestQuality();
            }

            if (self.endpointId()) {
                return self.loadEndpointData().then(function () {
                    self.summaryLoaded(true);
                });
            } else {
                self.summaryLoaded(true);
            }

        }).catch(function () {
            self.source('Unable to load Call Details');
            self.sourceIp('empty');
            self.target('');
            self.targetIp('empty');
            self.meetingName('');
            self.meetingId('');
            self.dataSource('');
            self.qualityDetailsUpdated(undefined);
            self.recordsUpdated(undefined);
            self.startTimeRaw('');
            self.endTimeRaw('');
            self.startDay('');
            self.startYear('');
            self.endDay('');
            self.startTime('');
            self.endTime('');
            self.quality('');
            self.avgQuality('');
            self.good('');
            self.fair('');
            self.bad('');
            self.unknown('');
            self.protocol('');
            self.bitrate('');
            self.mediaRouted(false);
            self.presentation(false);

            self.callType('');
            self.mos('');
            self.deviceType('');
            self.platform('');
            self.version('');
            self.platformVersionBR('');
            self.connection('');
            self.mediaNode('');
            self.disconnectReason('');
            self.disconnectDetails('');
            self.localIP('');
            self.publicIP('');
            self.audioCodecTx('');
            self.audioCodecRx('');
            self.videoCodecTx('');
            self.videoCodecRx('');
            self.presentationCodecTx('');
            self.presentationCodecRx('');
            self.perfCamera('');
            self.perfMicrophone('');
            self.perfSpeaker('');

        });

        function getMediaRoutedVal(dataSource, mediaRouted) {
            var text = mediaRouted ? 'Yes' : 'No';
            return (dataSource.toLowerCase() === 'vcs' ||
                    dataSource.toLowerCase() === 'vcsx' ||
                    dataSource.toLowerCase() === 'vcsc')
                ? text : 'N/A';
        }
    }

    loadLatestQuality() {
        var self = this;
        return WebResourceSecure.getJSON(self.baseUrlV1 + '/calls/' + self.data().call_id + '/' + self.data().start_time + '/quality/latest').then(function (latest) {
            self.audioCodecTx(_.get(latest, 'tx_audio.codec', ''));
            self.audioCodecRx(_.get(latest, 'rx_audio.codec', ''));
            self.videoCodecTx(_.get(latest, 'tx_video.codec', ''));
            self.videoCodecRx(_.get(latest, 'rx_video.codec', ''));
            self.presentationCodecTx(_.get(latest, 'tx_presentation.codec', ''));
            self.presentationCodecRx(_.get(latest, 'rx_presentation.codec', ''));

            function joinCodec(tx, rx) {
                let result = tx;
                if (result) {
                    result += ' (Sending)<br>';
                }
                if (rx) {
                    result += rx + ' (Receiving)';
                }
                return result;
            }

            self.audioCodecHtml(joinCodec(self.audioCodecTx(), self.audioCodecRx()));
            self.videoCodecHtml(joinCodec(self.videoCodecTx(), self.videoCodecRx()));
            self.presentationCodecHtml(joinCodec(self.presentationCodecTx(), self.presentationCodecRx()));
            return true;
        }).catch(function () {
            self.audioCodecTx('');
            self.audioCodecRx('');
            self.videoCodecTx('');
            self.videoCodecRx('');
            self.presentationCodecTx('');
            self.presentationCodecRx('');
        });
    }

    loadEndpointData() {
        var self = this;
        //https://qa-api.vyopta.com/cpmm/api/v1/orgs/201/endpoints?page=0&size=20&start=2018-12-04T22:13:28Z&end=2018-12-04T23:13:28Z&filter=name%3D%3D%22*1234*%22
        return WebResourceSecure.getJSON(self.baseUrl + '/endpoints/'+self.endpointId()).then(function (data) {
            if (data) {
                var ep = data;
                if (ep) {
                    self.sourceIp(ep.host_address);
                    self.deviceInfos(ep.device_infos);
                }
            }
            return true;
        }, function () {
            self.sourceIp('');
            self.microphone('');
            self.camera('');
            self.touchPanel('');
            self.display('');
            self.deviceInfos([]);
            self.endpointId(undefined);
            return true;
        });
    }

    setupCdrhTableColumnsDataAndFilter() {
        var self = this;
        self.cdrhTable.setColumns(self.cdrhColumns);
        self.cdrhTable.setData(self.cdrhData);
        self.twoPassFilter();
    }

    expandCdrhTable(expand) {
        var self = this;
        // todo keep trck of sort, filter
        self.cdrhTable.options.dataTreeStartExpanded = expand;
        self.cdrhTable._create();
        self.setupCdrhTableColumnsDataAndFilter();
    }

    isCdrhTableFullyExpanded() {
        let self = this;
        return self.areRowsExpanded(self.cdrhTable.getRows());
    }

    areRowsExpanded(rows) {
        let self = this;
        if (!_.isEmpty(rows)) {
            if (!_.every(rows, row => {
                return !_.get(row,'_row.modules.dataTree.children') || _.get(row,'_row.modules.dataTree.open');
            })) return false;

            if (!_.every(rows, row => {
                return self.areRowsExpanded(row.getTreeChildren());
            })) return false;
        }

        return true;
    }

    loadCDRData() {
        var self = this;

        return WebResourceSecure
            .getJSON(self.baseV1Url + '/calls/' + self.data().call_id + '/' + self.data().start_time + '/callrecords')
            .then(function (records) {
          self.parseCdrData(records);
        });
    }

    parseCdrData(records) {
        let self = this;
        self.records(records);
        let callRecordMetadata = self.callRecordMetadata;
        var cmrColumns = [
            {title:"Attribute", field:"attr", frozen:true, headerFilter:"input",
                tooltip: function(cell) {
                    var description = callRecordMetadata.cmrDescriptions[cell.getValue()];
                    return (description) ? description : false;
                }
            },
        ];
        var cmrValues = [];
        var cmrKeys = [];

        var cdrColumns = [
            {title:"Attribute", field:"attr", frozen:true, headerFilter:"input",
                tooltip: function(cell) {
                    var description = callRecordMetadata.cdrDescriptions[cell.getValue()];
                    return (description) ? description : false;
                }
            },
        ];
        var cdrValues = [];
        var cdrKeys = [];

        let cdrhAttrFormatter = function(cell, formatterParams, onRendered){
            let value = getElementMatching(callRecordMetadata.cdrhAttribute, cell.getData()['key']) || cell.getValue();
            if (cell.getRow().getTreeChildren() && cell.getRow().getTreeChildren().length > 0) {
                value = '<span class="parent-attr">' + value + '</span>';
            } else {
                value = '<i class="fas fa-caret-up tree-toggle tree-toggle-hidden"></i>' + value;
            }
            return value;
        };

        let cdrhAttrTitleFormatter = function(cell, formatterParams, onRendered){
            return cell.getValue() + ' <i class=\'far fa-question-circle\' title=\'Hover over any attribute to see its description.\'></i>';
            // return '<span class="tabulator-header-menu-button"><i class="fad fa-caret-circle-right" title="Collapse All" data-bind="click: expandCdrhTable.bind(this, false)"></i> <i class="fad fa-caret-circle-down" title="Expand All" data-bind="click: expandCdrhTable.bind(this, true)"></i></span>' + cell.getValue() + ' <i class=\'far fa-question-circle\' title=\'Hover over any attribute to see its description.\'></i>';
        };

        self.cdrhColumns = [
            {
                title:"Attribute",
                field:"attr",
                frozen:true,
                tooltip: function(cell) {
                    var description = getElementMatching(callRecordMetadata.cdrhDescriptions, cell.getData()['key']);
                    return (description) ? description : false;
                },
                // titleFormatter: cdrhAttrTitleFormatter,
                formatter: cdrhAttrFormatter,
                headerMenu: [
                    {
                        label:"<i class='fas fa-caret-down'></i> Expand All",
                        action:function(e, column){
                            self.expandCdrhTable(true);
                        }
                    },
                    {
                        label:"<i class='fas fa-caret-right'></i> Collapse All",
                        action:function(e, column){
                            self.expandCdrhTable(false);
                        }
                    }
                ]
            },
            {title:"Caller", field:"caller", tooltip:true, formatter: cdrhValueFormatter.bind(self)
            },
            {title:"Callee", field:"callee", tooltip:true, formatter: cdrhValueFormatter.bind(self)
            },
            {title:"Value", field:"value", tooltip:true, formatter: cdrhValueFormatter.bind(self)
            },
        ];
        var cdrhValues = [];

        records.forEach(function (record) {
            let type = record.record_value_type;

            if (type === 'KEY_VALUE_CMR') {
              let title = cmrColumns.length === 1 ? 'Value' : 'Value ' + cmrColumns.length;
              cmrColumns.push({title: title,
                    field:"val"+cmrColumns.length,
                    formatter: cmrValueFormatter.bind(self)
                });
                if (cmrValues.length === 0) {
                    cmrKeys = _.keys(record.values);
                }
                cmrValues.push(record.values);
            } else if (type === 'KEY_VALUE_CDR') {
              let title1 = cdrColumns.length === 1 ? 'Value' : 'Value ' + cdrColumns.length;
              cdrColumns.push({title: title1,
                    field:"val"+cdrColumns.length,
                    formatter: cdrValueFormatter.bind(self)
                });
                if (cdrValues.length === 0) {
                    cdrKeys = _.keys(record.values);
                }
                cdrValues.push(record.values);
            } else if (type === 'KEY_VALUE_CALLER_CALLEE') {
                if (typeof record.value == 'object') {
                    cdrhValues.push(record.value);
                } else if (typeof record.value == 'string') {
                    cdrhValues.push(JSON.parse(record.value));
                }
            }
        });

        var cmrData = [];
        if (cmrValues.length > 0) {
            cmrKeys.forEach(function (key) {
                var data = {};
                data.id = key;
                data.attr = key;
                cmrValues.forEach(function (val, index) {
                    data['val'+(index+1)] = val[key];
                });
                if (key.toLowerCase().indexOf('jitter') >= 0
                    || key.toLowerCase().indexOf('packet') >= 0
                    || key.toLowerCase().indexOf('latency') >= 0
                    || key.toLowerCase().indexOf('varvqmetrics') >= 0) {
                    cmrData.unshift(data);
                } else {
                    cmrData.push(data);
                }
            });

        }

        var cdrData = [];
        if (cdrValues.length > 0) {
            cdrKeys.forEach(function (key) {
                var data = {};
                data.id = key;
                data.attr = key;
                cdrValues.forEach(function (val, index) {
                    data['val'+(index+1)] = val[key];
                });
                if (key.toLowerCase().indexOf('cause_value') >= 0 
                  || key.toLowerCase().indexOf('userprincipalname') >= 0 
                  || key.toLowerCase().indexOf('finalsipcodenhrase') >= 0 
                  || key.toLowerCase().indexOf('finalsipcode') >= 0 
                  || key.toLowerCase().indexOf('successfulcall') >= 0 
                  || key.toLowerCase().indexOf('userdisplayname') >= 0 
                  || key.toLowerCase().indexOf('calltype') >= 0 
                 ) {
                    cdrData.unshift(data);
                } else {
                    cdrData.push(data);
                }
            });

        }

        self.cdrhData = [];
        let uid = { val: 1 };

        if (cdrhValues.length > 0) {
            self.cdrhData = self.processCdrhValues(callRecordMetadata, cdrhValues[0], uid);
        }


        self.hasCdrData(!_.isEmpty(cdrData));
        self.hasCmrData(!_.isEmpty(cmrData));
        self.hasCdrhData(!_.isEmpty(self.cdrhData));


        self.cmrTable.setColumns(cmrColumns);
        self.cmrTable.setData(cmrData);
        self.cdrTable.setColumns(cdrColumns);
        self.cdrTable.setData(cdrData);
        self.setupCdrhTableColumnsDataAndFilter();
    }
    processCdrhValues(callRecordMetadata, values, uid, prefix = '') {
        let self = this;
        let cdrhData = [];
        let cdrhKeys = _.keys(values);

        cdrhKeys.forEach(function (key) {
            let value = values[key];
            var data = {};
            data.id = uid.val;
            uid.val = uid.val + 1;

            // todo change how we transform values to server side
            let cdrhRendererElement = getElementMatching(callRecordMetadata.cdrhRenderer, prefix + key);

            function transformValue(val) {
                // todo change how we transform values to server side
                if (val && cdrhRendererElement) {
                    if ((_.startsWith(cdrhRendererElement, 'jitter') ||
                        _.startsWith(cdrhRendererElement, 'latency'))
                        && _.startsWith(val,'P')) {
                        val = moment.duration(val).milliseconds();
                    // } else if (_.startsWith(cdrhRendererElement, 'packetLoss')) {
                    //     val = val * 100; // todo we might not need to do this here
                    }
                }
                return val;
            }

            function setIfNotNull(path) {
                let value1 = _.get(value, path);
                if (value1 != null) {
                    _.set(data, path, transformValue(value1));
                }
            }


            data.attr = (getElementMatching(callRecordMetadata.cdrhAttribute, prefix + key) || key);
            data.key = (prefix + key);

            if (typeof value == 'object') {
                setIfNotNull('caller');
                setIfNotNull('callee');
                setIfNotNull('value');

                let children = self.processCdrhValues(callRecordMetadata, _.omit(value, 'caller', 'callee', 'value'), uid, prefix + key + '.' );
                if (children.length > 0) {
                    data._children = children;
                }
            } else {
                if (value != null) data.value = transformValue(value);
            }
            if (self.showDiagnostics) {
                self.checkForPoorQuality(data);
            }
            cdrhData.push(data);
        });

        return cdrhData;
    }

    checkForPoorQuality(data) {
        let currentKey = data.key;
        const FIVE_MILLION = 5*1000*1000;
        const ONE_MILLION = 1000*1000;
        let issues = this.callIssues();
        let threshold;
        switch (currentKey) {
            case 'main-audio.device.cpuInsufficientEventRatio':
                threshold = .05;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 1,
                        value: (data.caller * 100).toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Insufficient CPU Ratio (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'Close out all unnecessary applications, eliminate unnecessary browser tabs, and ensure your computer fan is not blocked.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 1,
                        value: (data.callee * 100).toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Insufficient CPU Ratio (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'Close out all unnecessary applications, eliminate unnecessary browser tabs, and ensure your computer fan is not blocked.'
                    });
                }
                break;
            case 'main-audio.network.linkSpeed':
                if (data.caller < FIVE_MILLION) {
                    issues.push({
                        rank: 2,
                        value: data.caller  + ' bps',
                        column: 'Low Link Speed (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'Consider any of the following steps: talk to your internet provider about lifting any data caps and/or negotiate a faster connection plan, move and/or reset your router, use an ethernet cable instead of wifi, consider an adblocker and antivirus software.'
                    });
                }
                if (data.callee < FIVE_MILLION) {
                    issues.push({
                        rank: 2,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' bps',
                        column: 'Low Link Speed (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'Consider any of the following steps: talk to your internet provider about lifting any data caps and/or negotiate a faster connection plan, move and/or reset your router, use an ethernet cable instead of wifi, consider an adblocker and antivirus software.'
                    });
                }
                break;
            case 'main-audio.network.wifiSignalStrength':
                if (data.caller > 0 && data.caller <= 80) {
                    issues.push({
                        rank: 3,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Low Wifi Signal Strength (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'Take steps to improve wifi signal strength including relocating closer to the wifi access point and consider administrator improvements like ensure QoS settings are being honored.'
                    });
                }
                if (data.callee > 0 && data.callee <= 80) {
                    issues.push({
                        rank: 3,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Low Wifi Signal Strength (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'Take steps to improve wifi signal strength including relocating closer to the wifi access point and consider administrator improvements like ensure QoS settings are being honored.'
                    });
                }
                break;
            case 'main-audio.network.bandwidthLowEventRatio':
                threshold = .05;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 4,
                        value: (data.caller * 100).toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Insufficient Bandwidth (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'Administrators should check for network-wide bandwidth constraints and end-users should follow bandwidth-boosting best practices like optimizing their location to the router, removing unnecessary devices from the network that are bandwidth intensive, and connecting to 5Ghz connections when possible.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 4,
                        value: (data.callee * 100).toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Insufficient Bandwidth (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'Administrators should check for network-wide bandwidth constraints and end-users should follow bandwidth-boosting best practices like optimizing their location to the router, removing unnecessary devices from the network that are bandwidth intensive, and connecting to 5Ghz connections when possible.'
                    });
                }
                break;
            case 'main-audio.network.wifiBand':
                if (data.caller === 'frequency24GHz') {
                    issues.push({
                        rank: 5,
                        value: 'Sub-optimal Wifi Band',
                        column: 'Sub Optimal Wifi Band (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'While a 2.4 GHz range might provide an adequate experience, especially if far from a wifi access point, the 5 GHz range is better suited to real-time media due to its dense range and it\'s recommended that users switch to 5 GHz bands if possible.'
                    });
                }
                if (data.callee === 'frequency24GHz') {
                    issues.push({
                        rank: 5,
                        value: 'Sub-optimal Wifi Band',
                        column: 'Sub Optimal Wifi Band (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'While a 2.4 GHz range might provide an adequate experience, especially if far from a wifi access point, the 5 GHz range is better suited to real-time media due to its dense range and it\'s recommended that users switch to 5 GHz bands if possible.'
                    });
                }
                break;
            case 'main-audio.stream.averagePacketLossRate':
                threshold = 1;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 6,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Audio Packet Loss (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 6,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Audio Packet Loss (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-video.stream.averagePacketLossRate':
                threshold = 1.5;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 7,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Video Packet Loss (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 7,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Video Packet Loss (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-presentation.stream.averagePacketLossRate':
            case 'applicationsharing-video.stream.averagePacketLossRate':
                threshold = 3;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 8,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Presentation Packet Loss (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 8,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + '%',
                        column: 'Presentation Packet Loss (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-audio.stream.averageJitter':
                threshold = 100;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 9,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Audio Jitter (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 9,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Audio Jitter (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-video.stream.averageJitter':
                threshold = 150;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 10,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Video Jitter (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 10,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Video Jitter (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-presentation.stream.averageJitter':
            case 'applicationsharing-video.stream.averageJitter':
                threshold = 500;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 11,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Presentation Jitter (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 11,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Presentation Jitter (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-audio.stream.averageRoundTripTime':
                threshold = 250;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 12,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Audio Latency (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 12,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Audio Latency (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-video.stream.averageRoundTripTime':
                threshold = 300;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 13,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Video Latency (Source/Caller)',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 13,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Video Latency (Target/Callee)',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-presentation.stream.averageRoundTripTime':
            case 'applicationsharing-video.stream.averageRoundTripTime':
                threshold = 750;
                if (data.caller >= threshold) {
                    issues.push({
                        rank: 14,
                        value: data.caller.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Presentation - (Send) - Latency',
                        helpful: ko.observable(''),
                        remediation: 'If the source/caller network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                if (data.callee >= threshold) {
                    issues.push({
                        rank: 14,
                        value: data.callee.toLocaleString('en-US', {maximumFractionDigits: 3}) + ' ms',
                        column: 'Presentation - (Receive) - Latency',
                        helpful: ko.observable(''),
                        remediation: 'If the target/callee network is a corporate network, send call details to the network team to troubleshoot further. If it\'s not a corporate network, encourage the network owner to follow connectivity best practices to improve network reliability.'
                    });
                }
                break;
            case 'main-audio.device.renderZeroVolumeEventRatio':
                if (data.caller === 100 || data.callee === 100) {
                    issues.push({
                        rank: 15,
                        value: 'Volume Off',
                        column: '',
                        helpful: ko.observable(''),
                        remediation: 'The user never turned up the volume and couldn\'t hear anything. Instruct the user to turn up the volume on their speaker'
                    });
                }
                break;
            case 'userAgent.applicationVersion':
                if (false) { // todo find parameters
                    issues.push({
                        rank: 16,
                        value: data.caller || data.callee,
                        column: data.attr,
                        helpful: ko.observable(''),
                        remediation: 'Update to the latest approved application version.'
                    });
                }
                break;
            default: break;
        }
        issues.sort(function(a, b) {
            return a.rank - b.rank;
        });
        this.callIssues(issues);
    }

    twoPassFilter() {
        var self = this;

        function firstPassFilterFunction(row) {
            let data = row.getData()
            let matchesOmni = true;
            if (self.omniFilter()) {
                let regExp = new RegExp(self.omniFilter(), 'i');
                matchesOmni = (data.attr && regExp.test(data.attr.toString()))
                    || (data.caller && regExp.test(data.caller.toString()))
                    || (data.callee && regExp.test(data.callee.toString()))
                    || (data.value && regExp.test(data.value.toString()));
            }
            let matchesSummary = !self.showSummary() || _.includes(self.callRecordMetadata.cdrhSummaryKeyFilter, data.key);
            return !!(matchesOmni && matchesSummary
                        && (self.showEmpty()
                            || (data.caller != null && data.caller !== '')
                            || (data.callee != null && data.callee !== '')
                            || (data.value != null && data.value !== '')));
        }

        function filterPassOne(rows) {
            let anyVisible = false;
            if (!_.isEmpty(rows)) {
                rows.forEach(row => {
                    self.filterResults[row.getIndex()] = filterPassOne(row.getTreeChildren())
                        || firstPassFilterFunction(row);
                    anyVisible = anyVisible || self.filterResults[row.getIndex()];
                });
            }
            return anyVisible;
        }

        self.filterResults = [];
        filterPassOne(self.cdrhTable.getRows());

        self.cdrhTable.setFilter(self.filterFunction);
    }



    recursivlyLoadRemainingChartData(data, starttime, endtime, canUseLast) {
        var self = this;

        var diff = endtime.diff(starttime);

      function safeData(metric) {
        return metric ? metric.data : undefined;
      }
      function findLast(dataObj) {
        return Object.values(dataObj).reduce((accumulator, category) => {
          accumulator.push(safeData(category.tx_audio), safeData(category.rx_audio), safeData(category.tx_video), 
            safeData(category.rx_video), safeData(category.tx_presentation), safeData(category.rx_presentation),
            safeData(category));
          return accumulator;
        }, []).map(a => a ? a.at(-1)[0]: 0).reduce((acc, current) => current > acc ? current : acc);
      }

      if (diff > TWO_HOURS) {
            const last = findLast(data);
          
            const next = last && canUseLast ? last+1 : starttime.valueOf() + TWO_HOURS;
            return WebResourceSecure.getJSON(self.baseUrlV1 + '/calls/' + self.data().call_id + '/' + self.data().start_time + '/quality/timeseriesdata?categories=tx_audio,rx_audio,tx_video,rx_video,tx_presentation,rx_presentation&metrics=jitter,packet_loss_rate,bitrate,latency,framerate,resolution_y,device_app_cpu,device_system_cpu,quality&start=' + next).then(function (data2) {
                return self.recursivlyLoadRemainingChartData(mergeChartData2(data, data2), next,  endtime, findLast(data2));
            });
        }
        return data;
    }

    loadQualityThresholds() {
        var self = this;

        return WebResourceSecure.getJSON(self.baseUrlV1Alert + '/quality/rules').then( function (data) {
          if (data && data[0]) {
            return data[0].thresholds; // todo this is suppose to be a list of rules and you match the first one based on call filtering
          }
          return null;
        });
    }

    loadAllChartData() {
        var self = this;

        var starttime = moment(self.startTimeRaw(), 'YYYY-MM-DDTHH:mm:ss.SSSZ');
        var endtime = (self.endTimeRaw()) ? moment(self.endTimeRaw(), 'YYYY-MM-DDTHH:mm:ss.SSSZ') : moment();

        return WebResourceSecure.getJSON(self.baseUrlV1 + '/calls/' + self.data().call_id + '/' + self.data().start_time + '/quality/timeseriesdata?categories=tx_audio,rx_audio,tx_video,rx_video,tx_presentation,rx_presentation&metrics=jitter,packet_loss_rate,bitrate,latency,framerate,resolution_y,device_app_cpu,device_system_cpu,quality').then( function (data) {
        // return WebResourceSecure.getJSON(self.baseUrl + '/calls/' + self.data().call_id + '/' + self.data().start_time + '/quality?metrics=packet_loss_rate,jitter,bitrate,framerate,latency,resolution_y').then( function (data) {
            return self.recursivlyLoadRemainingChartData(data,  starttime, endtime, true);
        });
    }

    updateLateancyDataStatus(self) {
        hasData = false;
        if (self.packetLossChart.series) {
            _.forEach(self.packetLossChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.hasPacketLossData(hasData);

        hasData = false;
        if (self.jitterChart.series) {
            _.forEach(self.jitterChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.hasJitterData(hasData);

        hasData = false;
        if (self.channelBitrateChart.series) {
            _.forEach(self.channelBitrateChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.hasChannelBitrateData(hasData);

        var hasData = false;
        if (self.latencyChart.series) {
            _.forEach(self.latencyChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.hasLatencyData(hasData);
        // todo make generic
        hasData = false;
        if (self.resolutionChart.series) {
            _.forEach(self.resolutionChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.hasResolutionData(hasData);

        hasData = false;
        if (self.framerateChart.series) {
            _.forEach(self.framerateChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.hasFramerateData(hasData);

        hasData = false;
        if (self.cpuChart.series) {
            _.forEach(self.cpuChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.hasCpuData(hasData);

        hasData = false;
        if (self.qotChart.series) {
            _.forEach(self.qotChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.hasQotData(hasData);
        
        hasData = false;
        if (self.qotChart.series) {
            _.forEach(self.qotChart.series, function (series) {
                hasData |= series.visible && series.options.data.length > 0;
            });
        }
        self.showQotHeader(hasData);
    }

    loadInitialChartData() {
        var self = this;

        $.each(self.allCharts, function (k, chart) {
          if (chart !== self.qotChart) {
            chart.showLoading(' ');
          }
        });

        // WIP currently we are blindly loading the entire call but we want to limit this to some reasonable time and give the user a UI button to load more
        self.loadAllChartData().then( function (dataObj) {
    
            // todo remove - this is building the data manually
            function buildData2(dataObj, prev) {
              console.time('build quality history');
              let results = [[] /*unk*/, [] /*good*/, [] /*fair*/, [] /*bad*/, [] /*qual pb*/, [] /*pl pb*/, [] /*jit pb*/, [] /*lat pb*/];

              let categories = {
                packet_loss_rate: dataObj.packet_loss_rate,
                jitter: dataObj.jitter,
                latency: dataObj.latency,
              };

              function safeArrayData(d, m) {
                if (!d || !d[m] || !d[m].data) return [];
                else return d[m].data;
              }
    
              function quality(d, i, good, bad) {
                if (d.length > i) {
                  if (d[i][1] < good) {
                    return 1; // good
                  }
                  if (d[i][1] > bad) {
                    return 3; // bad
                  }
                  return 2; // fair
                }
                return 0; // unknown
              }
  
              let data = dataObj.packet_loss_rate.rx_audio.data;
              if (data && self.thresholds) {
                data.forEach((d, i) => {

                  let qs = [];
                  for (const [categoryKey, category] of Object.entries(categories)) {
                    let catQs = [];
                    catQs.push(quality(safeArrayData(category,'tx_audio'), i, self.thresholds.good.live.tx.audio[categoryKey], self.thresholds.bad.live.tx.audio[categoryKey]));
                    catQs.push(quality(safeArrayData(category, 'rx_audio'), i, self.thresholds.good.live.rx.audio[categoryKey], self.thresholds.bad.live.rx.audio[categoryKey]));
                    catQs.push(quality(safeArrayData(category, 'tx_video'), i, self.thresholds.good.live.tx.video[categoryKey], self.thresholds.bad.live.tx.video[categoryKey]));
                    catQs.push(quality(safeArrayData(category, 'rx_video'), i, self.thresholds.good.live.rx.video[categoryKey], self.thresholds.bad.live.rx.video[categoryKey]));
                    catQs.push(quality(safeArrayData(category, 'tx_presentation'), i, self.thresholds.good.live.tx.presentation[categoryKey], self.thresholds.bad.live.tx.presentation[categoryKey]));
                    catQs.push(quality(safeArrayData(category, 'rx_presentation'), i, self.thresholds.good.live.rx.presentation[categoryKey], self.thresholds.bad.live.rx.presentation[categoryKey]));
                    
                    let catI = 5;
                    switch (categoryKey) {
                      case 'latency':
                        catI++;
                      case 'jitter':
                        catI++;
                      case 'packet_loss_rate':
                        let catQ = Math.max(...catQs);

                        // plotbands for jitter, pk, latency
                        if (i === 0 && !prev) {
                        } else {
                          let prevValue = (i === 0 && prev) ? prev : data[i - 1][0];
                          let colorClass = 'plot-band-unknown';
                          if (catQ === 1) {
                            colorClass = 'plot-band-good';
                          } else if (catQ === 2) {
                            colorClass = 'plot-band-fair';
                          } else if (catQ === 3) {
                            colorClass = 'plot-band-bad';
                          }

                          if (results[catI].length > 0 && results[catI].at(-1).className === colorClass) {
                            results[catI].at(-1).to = d[0];
                          } else {
                            results[catI].push({
                              className: colorClass,
                              from: prevValue + 1,
                              to: d[0],
                            });
                          }
                        }
                        
                        break;
                      default:
                    }
                    
                    qs.push(...catQs);
                  }
                  
                  let q = Math.max(...qs);
                  results[q].push([d[0], 4]);
                  
                  // plotbands
                  if (i === 0 && !prev) {
                  } else {
                    let prevValue = (i === 0 && prev) ? prev : data[i - 1][0];
                    let colorClass = 'plot-band-unknown';
                    if (q === 1) {
                      colorClass = 'plot-band-good';
                    } else if (q === 2) {
                      colorClass = 'plot-band-fair';
                    } else if (q === 3) {
                      colorClass = 'plot-band-bad';
                    }
                    if (results[4].length > 0 && results[4].at(-1).className === colorClass) {
                      results[4].at(-1).to = d[0];
                    } else {
                      results[4].push({
                        className: colorClass,
                        from: prevValue + 1,
                        to: d[0],
                      });
                    }
                  }
                });
              }
              console.timeEnd('build quality history');
              return results;
            }
            
            function joinData(category) {
                function safeArray(d) {
                    if (!d) return [];
                    else return d;
                }
                if (category) {
                    return [
                        safeArray(category.tx_audio.data),
                        safeArray(category.rx_audio.data),
                        safeArray(category.tx_video.data),
                        safeArray(category.rx_video.data),
                        safeArray(category.tx_presentation.data),
                        safeArray(category.rx_presentation.data),
                    ];
                } else {
                    return [[],[],[],[],[],[]];
                }
            }

            let data =
                joinData(dataObj.packet_loss_rate).
                concat(joinData(dataObj.jitter)).
                concat(joinData(dataObj.bitrate)).
                concat(joinData(dataObj.frame_rate)).
                concat(joinData(dataObj.latency)).
                concat(joinData(dataObj.resolution_y));

 
            var last = 0;
            $.each(data, function (i, d) {
                // todo this only works if every chart has 6 series
                var chartIndex = Math.floor(i/6);
                var seriesIndex = i - (chartIndex*6);
                if (self.charts.length > chartIndex) {
                    self.charts[chartIndex].series[seriesIndex].setData(d, false);
                    if ((d.length > 0)) {
                        var next = d[d.length - 1][0];
                        if (next > last) {
                            last = next;
                        }
                    }
                }
            });
            last += 1;

            if (dataObj.packet_loss_rate.plot_bands && dataObj.packet_loss_rate.plot_bands.data) {
              dataObj.packet_loss_rate.plot_bands.data.forEach( b => self.packetLossChart.xAxis[0].addPlotBand(b));
            }
            if (dataObj.jitter.plot_bands && dataObj.jitter.plot_bands.data) {
              dataObj.jitter.plot_bands.data.forEach( b => self.jitterChart.xAxis[0].addPlotBand(b));
            }
            if (dataObj.latency.plot_bands && dataObj.latency.plot_bands.data) {
              dataObj.latency.plot_bands.data.forEach( b => self.latencyChart.xAxis[0].addPlotBand(b));
            }


          // todo CPU
            if (dataObj.device_app_cpu) self.cpuChart.series[0].setData(dataObj.device_app_cpu.data, false);
            if (dataObj.device_system_cpu) self.cpuChart.series[1].setData(dataObj.device_system_cpu.data, false);
            

            if (dataObj.quality) {
              if (dataObj.quality.good && dataObj.quality.good.data) {
                self.qotChart.series[0].setData(dataObj.quality.good.data, false);
              }
              if (dataObj.quality.fair && dataObj.quality.fair.data) {
                self.qotChart.series[1].setData(dataObj.quality.fair.data, false);
              }
              if (dataObj.quality.bad && dataObj.quality.bad.data) {
                self.qotChart.series[2].setData(dataObj.quality.bad.data, false);
              }
              if (dataObj.quality.unknown && dataObj.quality.unknown.data) {
                self.qotChart.series[3].setData(dataObj.quality.unknown.data, false);
              }
              if (dataObj.quality.plot_bands && dataObj.quality.plot_bands.data) {
                dataObj.quality.plot_bands.data.forEach( b => self.qotChart.xAxis[0].addPlotBand(b));
              }
            }
            
            $.each(self.allCharts, function (k, chart) {
                if (chart === self.latencyChart || chart === self.resolutionChart || chart === self.cpuChart || chart === self.qotChart) {
                    if (chart.xAxis[0].setExtremes) {
                      chart.xAxis[0].setExtremes(self.packetLossChart.xAxis[0].min, self.packetLossChart.xAxis[0].max, false, false);
                    }
                }
                chart.redraw(false);
                chart.hideLoading();
            });

            self.updateLateancyDataStatus(self);

            if (!self.endTimeRaw()) { // live call
                self.subscription = Rx.Observable
                    .timer(10 * 1000, 10 * 1000)
                    .subscribe(function () {
                        self.loadSummaryData().then(function () {
                            WebResourceSecure.getJSON(self.baseUrlV1 + '/calls/' + self.data().call_id + '/' + self.data().start_time + '/quality/timeseriesdata?categories=tx_audio,rx_audio,tx_video,rx_video,tx_presentation,rx_presentation&metrics=jitter,packet_loss_rate,bitrate,latency,framerate,resolution_y,resolution_y,device_app_cpu,device_system_cpu,quality&start=' + last).then(function (dataObj) {

                                let resetExtremes = self.packetLossChart.xAxis[0].getExtremes().max === self.packetLossChart.xAxis[0].getExtremes().dataMax;
 
                                let prevLast = last;
                                
                                let data =
                                    joinData(dataObj.packet_loss_rate).
                                    concat(joinData(dataObj.jitter)).
                                    concat(joinData(dataObj.bitrate)).
                                    concat(joinData(dataObj.frame_rate)).
                                    concat(joinData(dataObj.latency)).
                                    concat(joinData(dataObj.resolution_y));
 
  
                                $.each(data, function (i, d) {
                                    // todo this only works if every chart has 6 series
                                    var chartIndex = Math.floor(i/6);
                                    var seriesIndex = i - (chartIndex*6);
                                    if (self.charts.length > chartIndex) {
                                        $.each(d, function (j, value) {
                                            self.charts[chartIndex].series[seriesIndex].addPoint(value, false);
                                            if (value[0] > last) {
                                                last = value[0];
                                            }
                                        });
                                    }
                                });

                                if (dataObj.packet_loss_rate.plot_bands && dataObj.packet_loss_rate.plot_bands.data) {
                                  dataObj.packet_loss_rate.plot_bands.data.forEach( b => self.packetLossChart.xAxis[0].addPlotBand(b));
                                }
                                if (dataObj.jitter.plot_bands && dataObj.jitter.plot_bands.data) {
                                  dataObj.jitter.plot_bands.data.forEach( b => self.jitterChart.xAxis[0].addPlotBand(b));
                                }
                                if (dataObj.latency.plot_bands && dataObj.latency.plot_bands.data) {
                                  dataObj.latency.plot_bands.data.forEach( b => self.latencyChart.xAxis[0].addPlotBand(b));
                                }
  
  
                                if (dataObj.device_app_cpu) {
                                    $.each(dataObj.device_app_cpu.data, function (j, value) {
                                        self.cpuChart.series[0].addPoint(value, false);
                                    });
                                }
                                if (dataObj.device_system_cpu) {
                                    $.each(dataObj.device_system_cpu.data, function (j, value) {
                                        self.cpuChart.series[1].addPoint(value, false);
                                    });
                                }


                              if (dataObj.quality) {
                                if (dataObj.quality.good && dataObj.quality.good.data) {
                                  $.each(dataObj.quality.good.data, function (j, value) {
                                    self.qotChart.series[0].addPoint(value, false);
                                  });
                                }
                                if (dataObj.quality.fair && dataObj.quality.fair) {
                                  $.each(dataObj.quality.fair.data, function (j, value) {
                                    self.qotChart.series[1].addPoint(value, false);
                                  });
                                }
                                if (dataObj.quality.bad && dataObj.quality.bad.data) {
                                  $.each(dataObj.quality.bad.data, function (j, value) {
                                    self.qotChart.series[2].addPoint(value, false);
                                  });
                                }
                                if (dataObj.quality.plot_bands && dataObj.quality.plot_bands.data) {
                                  dataObj.quality.plot_bands.data.forEach(b => self.qotChart.xAxis[0].addPlotBand(b));
                                }
                              }


                                self.updateLateancyDataStatus(self);
                              
                                $.each(self.allCharts, function (k, chart) {
                                    if (resetExtremes) {
                                      chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().min, last);
                                    }
                                    chart.redraw();
                                });

                              if (last !== prevLast) {
                                last += 1;
                              }
                            }); // todo WIP onError

                            if (self.endTimeRaw()) {
                                self.subscription.dispose();
                            }
                        });
                    });
            }

        });
    }

    cleanupSubscriptions() {
        if (this.subscription) { this.subscription.dispose(); }
        if (this.omniSubsciption) { this.omniSubsciption.dispose(); }
        if (this.showEmptySubsciption) { this.showEmptySubsciption.dispose(); }
        if (this.showSummarySubsciption) { this.showSummarySubsciption.dispose(); }
    }

    openInNewPage() {
        window.open(this.openUrlInNewPage(), '_blank');
    }

    dispose() {
        this.cleanupSubscriptions();
        if (this.routeSubscription) { this.routeSubscription.dispose(); }
        if (this.observer) { this.observer.disconnect(); }
    }
}

function cmrValueFormatter(cell, formatterParams, onRendered){
    var value = cell.getValue();
    if (value) {
        var cellAttr = cell.getRow().getData()['attr'];
        if (cellAttr) {
            var mapping = this.callRecordMetadata.cmrMapping[cellAttr];
            if (mapping) {
                var map = this.callRecordMetadata.maps[mapping];
                if (map) {
                    var mappedValue = map[''+value];
                    if (mappedValue) {
                        value = mappedValue;
                    }
                }
            }
        }
    }
    return value;
}
function cdrValueFormatter(cell, formatterParams, onRendered){
    var value = cell.getValue();
    if (value) {
        var cellAttr = cell.getRow().getData()['attr'];
        if (cellAttr) {
            var mapping = this.callRecordMetadata.cdrMapping[cellAttr];
            if (mapping) {
                var map = this.callRecordMetadata.maps[mapping];
                if (map) {
                    var mappedValue = map[''+value];
                    if (mappedValue) {
                        value = mappedValue;
                    }
                }
            }
        }
    }
    return value;
}

function cdrhValueFormatter(cell, formatterParams, onRendered){
    let value = cell.getValue();
    let cdrhRendererElement = getElementMatching(this.callRecordMetadata.cdrhRenderer, cell.getData()['key']);

    if (value != null && value !== '') {
        if (cdrhRendererElement) {
            if (_.startsWith(cdrhRendererElement, 'jitter') ||
                _.startsWith(cdrhRendererElement, 'packetLoss') ||
                _.startsWith(cdrhRendererElement, 'latency')) {
                // todo change how we determine quality - from server side data
                let channel = this.callRecordMetadata.cdrhKeyToChannel[cell.getRow().getTreeParent().getData()['key']];
                let className = UtilsService.formatThreshold(cdrhRendererElement.split(' ')[0], channel, ['fonticonGreen', 'fonticonYellow', 'fonticonRed'],'', value);

                if (_.startsWith(cdrhRendererElement, 'jitter') ||
                    _.startsWith(cdrhRendererElement, 'latency')) {
                    value = value + ' ms';
                } else if (_.startsWith(cdrhRendererElement, 'packetLoss')) {
                    value = getReadablePacketLossString(value);
                }

                if (className) {
                    let icon = 'fas fa-circle';
                    if (_.endsWith(cdrhRendererElement, 'max')) {
                        icon = 'far fa-arrow-to-top'
                    } else if (_.endsWith(cdrhRendererElement, 'correct')) {
                        icon = 'far fa-table-cells'
                    }
                    value = '<i class="' + icon + ' ' + className +'"></i> ' + value;
                }
            } else if (cdrhRendererElement === 'linkSpeed') {
                value = getBitrateIcon(value) + getReadableBitrateString2(value);
            } else if (cdrhRendererElement === 'bandwidth') {
                value = getReadableBitrateString(value);
            } else if (cdrhRendererElement === 'framerate') {
                value = getReadableFramerateString(value);
            } else if (cdrhRendererElement === 'percentage') {
                value = getReadablePercentageString(value);
            } else if (cdrhRendererElement === 'dB') {
                value = getReadableDbString(value);
            } else if (cdrhRendererElement === 'ratio') {
                value = getReadableRatioString(value);
            }
        } else {
            let cellAttr = cell.getData()['key'];
            if (cellAttr) {
                let mapping = getElementMatching(this.callRecordMetadata.cdrhMapping, cellAttr);
                if (mapping) {
                    let map = this.callRecordMetadata.maps[mapping];
                    if (map) {
                        let mappedValue = map[''+value];
                        if (mappedValue) {
                            value = mappedValue;
                        }
                    }
                }
            }
        }
    }

    return value;
}

function getElementMatching(obj, key) {
    if (obj[key]) {
        return obj[key];
    }
    let found = _.find(_.keys(obj), function(k){
        return _.endsWith(key, k);
    })
    if (found) {
        return obj[found];
    }
    return null;
}

// todo: from singleFilter/admin, should probably make a service for this
function getLogoImage(key) {
  let imgUrl = '';
  let imgUrl250 = '';
  switch(key) {
    case "ACMEPACKET": imgUrl = '40x40-oracle-acme-pack.png'; imgUrl250 = '250x250-oracle-acme-pack.png'; break;
    case "AURASM": imgUrl = '40x40-avaya.png'; imgUrl250 = '250x250-avaya.png'; break;
    case "ACANO": case "CMS": imgUrl = '40x40-cms.png'; imgUrl250 = '250x250-cms.png'; break;
    case "BJN": case "BlueJeans": imgUrl = '40x40-bluejeans.png'; imgUrl250 = '250x250-bluejeans.png'; break;
    case "CISCOCH": case "CISCOWEBEX": case "CMS": case "CTPS": case "CUBE": case "CUCM": case "CUCM CDR": case "MCU": case "TMS": case "TPE": case "VCS": case "VCSX": case "WEBEX": imgUrl = '40x40-cisco.png'; imgUrl250 = '250x250-cisco.png'; break;
    case "CHIME": imgUrl = '40x40-amazonChime.png'; imgUrl250 = '250x250-AmazonChime.png'; break;
    case "CSPRK": case "CISCOWEBEX": imgUrl250 = '250x250-cisco-webex.png'; break;
    case "CUSTOM": case "CSV": case "CUSTOMCLOUD": imgUrl = '40x40-csv.png'; imgUrl250 = '250x250-csv.png'; break;
    case "DMA": case "RPRM": case "RMX": case "RPAD": case "POLYLENS": imgUrl = '40x40-poly.png'; imgUrl250 = '250x250-poly.png';  break;
    case "EPDOCS": imgUrl = '40x40-epdocs.png'; break;
    case "EPM": imgUrl = '20x20-vyopta.png'; break;
    case "EXCHG": imgUrl = '40x40-ms-exch.png'; imgUrl250 = '250x250-MSExch.png'; break;
    case "GCAL": imgUrl = '40x40-gcal.png'; imgUrl250 = '250x250-gcal.png'; break;
    case "GMEET": case "GMEET CDR": case "Google Meet": imgUrl = '40x40-gmeet.png'; imgUrl250 = '250x250-gmeet.png'; break;
    case "GOTO": imgUrl = '40x40-goto.png'; break;
    case "ISDN": imgUrl = 'isdn.jpg'; imgUrl250 = 'isdn.jpg'; break;
    case "MSTEAMS": case "MSTEAMS CDR": case "MSTEAMS DR CDR": case "MSTEAMS PSTN CDR": imgUrl = '40x40-ms-teams.png'; imgUrl250 = '250x250-ms-teams.png'; break;
    case "NEATPULSE": imgUrl = '40x40-neat.png'; break;
    case "OFFICE365": imgUrl = '40x40-off365.png'; imgUrl250 = '250x250-Office365.png'; break;
    case "PEXIP": case "PEXIPERM": imgUrl = '40x40-pexip.png'; imgUrl250 = '250x250-pexip.png'; break;
    case "RINGCENTRAL": imgUrl = '40x40-ringcentral.png'; imgUrl250 = '250x250-RingCentral.png'; break;
    case "SKYPE": case "LYNC": imgUrl = 'skype.png'; imgUrl250 = 'skype.png'; break;
    case "VIDYO": imgUrl = 'vidyo.png'; imgUrl250 = 'vidyo.png'; break;
    case "WEBEX": case "WEBEX (legacy)": imgUrl250 = '250x250-webex-legacy.png'; break;
    case "ZOOM": case "ZOOMPHONE": imgUrl = 'zoom.png'; imgUrl250 = '250x250-zoom.png'; break;
    default: break;
  }
  if (imgUrl) {
    imgUrl = 'dist/images/systems/' + imgUrl;
  }
  return imgUrl;
}

export default {
    components: {NetworksSteps},
    template: templateMarkup, viewModel: CallDetailsView };
